// Automatisch aus /app/vorlagen/startseite_vorlage_*.html erzeugt (gen_langs.mjs) — Texte 1:1 aus den Vorlagen.
// Nur Formular-Statusmeldungen (ok/sending/err) sind sinngemäß übersetzt.
export const HOME_COPY_LANGS = {
 "fr": {
  "nav": [
   [
    "#loesungen",
    "Solutions"
   ],
   [
    "#kombinieren",
    "Tailles"
   ],
   [
    "#nachweis",
    "Preuve"
   ],
   [
    "#anwendungen",
    "Usages"
   ],
   [
    "#foerderung",
    "Financement"
   ],
   [
    "#kontakt",
    "Contact"
   ]
  ],
  "cta": "Prendre contact",
  "badge": {
   "foto": "PHOTO",
   "video": "VIDÉO",
   "vorf": "DÉMONSTRATION",
   "heute": "AUJOURD’HUI · PHOTO",
   "morgen": "DEMAIN · VISUALISATION",
   "vis": "VISUALISATION",
   "bg": "ARRIÈRE-PLAN : VISUALISATION"
  },
  "hero": {
   "kicker": "INFRASTRUCTURE URBAINE ADAPTÉE AU CLIMAT",
   "h1a": "Des zones de sécurité",
   "h1b": "deviennent des ",
   "h1c": "lieux de vie.",
   "p": "De l’ombre, des arbres, de l’eau de pluie et des places assises pour les centres-villes qui surchauffent. Et en plus, une protection anti-véhicule testée lors d’un crash-test DEKRA. Un système modulaire, de nombreuses solutions.",
   "a": "Voir les solutions"
  },
  "facts": [
   [
    "1,44 m²",
    "de végétation par module"
   ],
   [
    "environ 190 litres",
    "de stockage d’eau de pluie par module « ville éponge », selon calcul"
   ],
   [
    "IWA 14-1",
    "Crash-test DEKRA · 7 114 kg · 63,9 km/h"
   ],
   [
    "EP 3 486 374",
    "Brevet européen"
   ]
  ],
  "fuer": [
   "POUR",
   [
    "Villes et communes",
    "Urbanisme et services des espaces verts",
    "Associations de commerçants et organisateurs d’événements",
    "Quartiers et investisseurs"
   ]
  ],
  "manifest": {
   "h2": "Nous nous sommes habitués au béton.",
   "p1": "Aux barrières rouges et blanches devant les églises. Aux grilles devant chaque marché de Noël. Aux places qui ressemblent à des chantiers.",
   "p2": "Alors qu’à cet endroit précis, il pourrait y avoir un arbre. Un banc. De l’ombre par une journée chaude.",
   "claim1": "La sécurité n’a pas besoin de se voir.",
   "claim2": "Elle doit se vivre.",
   "alt": "Entrée d’un marché de Noël berlinois avec barrières rouges et blanches et plaques au sol jaunes et noires",
   "cap": "Marché de Noël sur la Breitscheidplatz, Berlin."
  },
  "hm": {
   "kicker": "BREITSCHEIDPLATZ, BERLIN",
   "h2a": "Même lieu. ",
   "h2b": "Autre ambiance.",
   "heute": "Aujourd’hui",
   "morgen": "Demain",
   "altH": "La Breitscheidplatz aujourd’hui : blocs de béton et tentes devant l’église du Souvenir",
   "altM": "La Breitscheidplatz demain : Berlin-Cubes avec arbres, bancs et lumière devant l’église du Souvenir",
   "capH": "Aujourd’hui : blocs de béton, grilles et rubalise devant l’église du Souvenir. C’est sûr, mais personne n’a envie de s’y arrêter.",
   "capM": "Demain : la même sécurité, avec des arbres, des bancs, de la lumière et de l’ombre. Une place où l’on se retrouve."
  },
  "prinzip": {
   "kicker": "LE PRINCIPE",
   "h2a": "Un module.",
   "h2b": "Cinq fonctions.",
   "p": "À la place des blocs de béton et des bornes : un module en acier galvanisé à chaud qui protège tout en rafraîchissant, en végétalisant et en invitant à s’arrêter. Posé sans fondation, démontable sans laisser de traces.",
   "alt": "Berlin-Cube planté de lavande dans la Kantstraße, Berlin",
   "items": [
    [
     "Climat et CO₂",
     "Arbres et plantes stockent du CO₂, donnent de l’ombre et rafraîchissent par évapotranspiration. La pluie reste dans le substrat au lieu de partir à l’égout."
    ],
    [
     "Végétalisation",
     "De la verdure même sur des places imperméabilisées et au-dessus des réseaux, sans fosse de plantation."
    ],
    [
     "Convivialité",
     "S’asseoir, respirer, s’attarder. Avec de la lumière le soir."
    ],
    [
     "Ville intelligente",
     "Solaire, recharge, information : conçu comme une plateforme."
    ],
    [
     "Sécurité",
     "Protection anti-véhicule, testée lors d’un crash-test DEKRA selon IWA 14-1:2013."
    ]
   ]
  },
  "loesungen": {
   "kicker": "LES SOLUTIONS",
   "h2a": "Un système de base.",
   "h2b": "Neuf réponses pour la ville.",
   "p": "Toutes les variantes reposent sur le Cube testé et sa liaison par câble. Les équipements sont des concepts en cours de développement. Pour chacun, il existe un PDF détaillé avec plans et explications. Nous vous l’envoyons volontiers.",
   "feat": {
    "tag": "VILLE ÉPONGE",
    "h3": "Pluie, espace racinaire et lieu de pause dans un seul module.",
    "alt": "Coupe d’un Cube ville éponge avec réservoir d’eau et racines qui descendent dans le sol par le fond ouvert",
    "li": [
     "Environ 190 litres de stockage par module selon calcul, plus l’eau collectée sur le pavage",
     "Fond ouvert : les racines descendent dans le sol",
     "Des arbres sur des places imperméabilisées",
     "Électricité, données et eau via un caniveau technique prévu"
    ],
    "cta": "Demander le concept Ville éponge"
   },
   "more": "Demander le concept →",
   "cards": [
    [
     "baum",
     "Arbre & ombre",
     "Des arbres sur le pavage et au-dessus des réseaux, en trois tailles.",
     "Grand Cube arboré avec banc sur une place"
    ],
    [
     "klima",
     "Climat",
     "Rafraîchir les îlots de chaleur : ombre, évaporation, brumisation.",
     "Cubes climat avec voile d’ombrage au-dessus des places assises"
    ],
    [
     "wasser",
     "Eau",
     "Fontaine à boire et brumisation, intégrées au Cube.",
     "Brumisation entre des Cubes plantés lors d’une journée de canicule"
    ],
    [
     "solar",
     "Solaire & recharge",
     "Électricité propre pour l’éclairage et les vélos électriques, raccordement réseau pour les voitures.",
     "Cube avec toit solaire au-dessus d’un banc"
    ],
    [
     "licht",
     "Lumière",
     "Des places claires et sûres le soir, éclairage piloté par capteurs et respectueux des insectes.",
     "Cubes lumineux le soir devant l’église du Souvenir"
    ],
    [
     "bank",
     "Banc",
     "S’asseoir et protéger à la fois : un banc sur trois poutres en acier HEB.",
     "Banc entre deux Cubes plantés le soir"
    ],
    [
     "service",
     "Services & info",
     "Déchets, information urbaine et publicité, intégrés plutôt qu’ajoutés.",
     "Place avec Cubes pour déchets, information et publicité"
    ],
    [
     "mobil",
     "Mobile",
     "Une protection anti-véhicule qui s’ouvre pour les pompiers, les secours et les livraisons.",
     "Cubes mobiles sur roues comme protection anti-véhicule ouvrable"
    ]
   ],
   "note": "Toutes les images de cette section sont des visualisations. État des concepts : octobre 2026."
  },
  "groessen": {
   "kicker": "TAILLES ET COMBINAISONS",
   "h2a": "Devant, la protection.",
   "h2b": "Derrière, l’ombre.",
   "p1": "Une rangée testée de Cubes de 1,20 m sécurise l’accès. Derrière, des Cubes plus grands accueillent des arbres pour l’ombre, la fraîcheur et le stockage du CO₂. Ainsi, une barrière devient une véritable place.",
   "p2": "Toutes les tailles dans la même construction et le même design, librement combinables avec banc, lumière, eau et solaire.",
   "sizes": [
    [
     "1,20 m",
     "Testé",
     72,
     72,
     "#141712"
    ],
    [
     "1,50 m",
     "En développement",
     90,
     90,
     "#3a4234"
    ],
    [
     "2,00 m",
     "En développement",
     120,
     120,
     "#5b6353"
    ],
    [
     "3,00 × 2,00 m",
     "En projet",
     180,
     120,
     null
    ],
    [
     "3,00 × 3,00 m",
     "En projet",
     180,
     180,
     null
    ]
   ],
   "note": "Emprises au sol représentées à l’échelle."
  },
  "vergleich": {
   "kicker": "LA COMPARAISON",
   "h2a": "Ce que fait une barrière. ",
   "h2b": "Et ce que fait un Cube.",
   "head": [
    "Bloc de béton",
    "Borne",
    "Berlin-Cube"
   ],
   "rows": [
    [
     "Protection anti-véhicule",
     "selon le produit",
     "selon le produit",
     "testé selon IWA 14-1"
    ],
    [
     "Végétalisation",
     "—",
     "—",
     "1,44 m² par module"
    ],
    [
     "Eau de pluie",
     "—",
     "—",
     "reste dans le substrat"
    ],
    [
     "Ombre et fraîcheur",
     "—",
     "—",
     "avec arbre ou voile d’ombrage"
    ],
    [
     "Places assises",
     "—",
     "—",
     "oui"
    ],
    [
     "Lumière le soir",
     "—",
     "parfois",
     "arêtes LED de série"
    ],
    [
     "Sans fondation",
     "oui",
     "le plus souvent non",
     "oui"
    ],
    [
     "Effet dans l’espace urbain",
     "zone interdite",
     "barrière",
     "lieu où s’arrêter"
    ]
   ]
  },
  "nachweis": {
   "kicker": "LA PREUVE",
   "h2a": "Nous l’avons",
   "h2b": "percuté exprès.",
   "dl": [
    [
     "Norme",
     "IWA 14-1:2013"
    ],
    [
     "Véhicule",
     "7 114 kg"
    ],
    [
     "Vitesse",
     "63,9 km/h"
    ],
    [
     "Zone sûre",
     "à partir de 7,95 m derrière le module"
    ],
    [
     "Rapport d’essai",
     "DEKRA n° 201844624"
    ]
   ],
   "note": "Sont testés le Cube et sa liaison par câble. Prochaine génération : crash-test selon ISO 22343-1 en projet."
  },
  "realisiert": {
   "kicker": "RÉALISÉ",
   "h2a": "Pas demain. ",
   "h2b": "Aujourd’hui.",
   "all": "Voir tous les projets →",
   "items": [
    [
     "video",
     "Vidéo : Berlin-Cubes éclairés dans la Kantstraße au coucher du soleil",
     "Projet pilote Kantstraße, Berlin",
     "De juin à septembre 2026. Posé sans fondation, démonté sans laisser de traces."
    ],
    [
     "foto",
     "Banc avec assise en bois sur un Berlin-Cube planté dans la Kantstraße, de jour",
     "S’asseoir plutôt que barrer",
     "Bancs, verdure et protection anti-véhicule sur une même ligne."
    ],
    [
     "vorf",
     "Démonstration de trois Berlin-Cubes avec rampe devant un centre outlet à Wustermark",
     "Wustermark, Brandebourg",
     "Démonstration devant un centre outlet : rampe, borne de recharge, arbre."
    ]
   ]
  },
  "ablauf": {
   "kicker": "DÉROULEMENT D’UN PROJET",
   "h2a": "Un seul interlocuteur. ",
   "h2b": "En quatre étapes.",
   "steps": [
    [
     "Demande",
     "Vous nous présentez votre site et ce qu’il doit apporter."
    ],
    [
     "Site et financement",
     "Nous étudions le lieu et identifions les financements possibles."
    ],
    [
     "Conception",
     "Implantation, variantes, plantations et éclairage pour votre site."
    ],
    [
     "Livraison et pose",
     "Délai de livraison d’environ 2 à 3 mois selon les quantités. Pose sans fondation."
    ]
   ]
  },
  "anwendungen": {
   "kicker": "USAGES",
   "h2a": "Par où voulez-vous ",
   "h2b": "commencer ?",
   "links": [
    [
     "/en/climate-adaptation-street-space",
     "Adaptation climatique et protection contre la chaleur"
    ],
    [
     "/en/vehicle-security-barriers-pedestrian-zones",
     "Rues piétonnes et centres-villes"
    ],
    [
     "/en/vehicle-security-barriers-christmas-markets",
     "Marchés de Noël"
    ],
    [
     "/en/vehicle-barriers-events",
     "Événements et fêtes urbaines"
    ],
    [
     "/en/vehicle-protection-cultural-venues",
     "Sites culturels et places"
    ],
    [
     "/en/vehicle-protection-government-buildings",
     "Administrations et bâtiments publics"
    ]
   ]
  },
  "foerderung": {
   "kicker": "FINANCEMENT",
   "h2a": "Un seul interlocuteur pour ",
   "h2b": "la solution et son financement.",
   "p": "Adaptation climatique, ville éponge, végétalisation et qualité de l’espace public : ces thèmes peuvent bénéficier de financements publics, nationaux ou européens. Nous vous aidons à identifier la piste adaptée à votre site.",
   "cta": "Demander un premier avis"
  },
  "presse": {
   "quote": "« C’est mieux que de tout barricader. »",
   "by": "Kirstin Bauch, maire de l’arrondissement de Charlottenburg-Wilmersdorf (Berlin), dans la Berliner Morgenpost (traduit de l’allemand)",
   "kicker": "ILS EN ONT PARLÉ",
   "list": "rbb24 Abendschau · radio3 · Tagesspiegel · Berliner Morgenpost · Entwicklungsstadt Berlin"
  },
  "erfinder": {
   "kicker": "INVENTEUR ET FABRICANT",
   "h2a": "Inventé à Berlin.",
   "h2b": "Fabriqué dans le Brandebourg.",
   "p1": "Martin Fichtelmann a conçu le Cube et l’a protégé par le brevet européen EP 3 486 374. Paysagiste de métier, il sait ce dont les plantes ont besoin sur une place urbaine, et il fabrique le Cube à Wustermark, près de Berlin.",
   "p2": "Un seul interlocuteur, de la première idée à l’entretien.",
   "alt": "Martin Fichtelmann, Erfinder des Berlin-Cube, am Breitscheidplatz in Berlin"
  },
  "kontakt": {
   "kicker": "CONTACT",
   "h2a": "Imaginez votre place",
   "h2b": "dans un an.",
   "p": "Nous vous montrons à quoi elle peut ressembler. Et comment la financer.",
   "p2": "Dites-nous en quelques mots où et quoi. Vous recevrez les documents souhaités par e-mail, ainsi qu’un premier avis de notre part, avec les pistes de financement possibles.",
   "addr": "Berliner Allee 37–39, 14641 Wustermark, Allemagne",
   "f": {
    "name": "Nom",
    "org": "Ville, commune ou organisation",
    "email": "E-mail",
    "ort": "Type de lieu",
    "orte": [
     "Place ou rue piétonne",
     "Marché de Noël ou événement",
     "Îlot de chaleur ou adaptation climatique",
     "Site culturel ou administration",
     "Autre"
    ],
    "laenge": "Longueur approximative en mètres",
    "msg": "Message",
    "legend": "Quels documents pouvons-nous vous envoyer ?",
    "docs": [
     [
      "foerderleitfaden",
      "Guide de financement (en allemand)"
     ],
     [
      "schwammstadt",
      "Ville éponge"
     ],
     [
      "baum",
      "Arbre & ombre"
     ],
     [
      "klima",
      "Climat"
     ],
     [
      "wasser",
      "Eau"
     ],
     [
      "solar",
      "Solaire & recharge"
     ],
     [
      "licht",
      "Lumière"
     ],
     [
      "bank",
      "Banc"
     ],
     [
      "service",
      "Services & info"
     ],
     [
      "mobil",
      "Mobile"
     ]
    ],
    "hint1": "Nous utilisons vos données uniquement pour répondre à votre demande. Plus d’informations dans la ",
    "hintLink": "politique de confidentialité",
    "hint2": ".",
    "submit": "Envoyer la demande et recevoir les documents",
    "sending": "Envoi en cours …",
    "ok": "Merci ! Nous vous contacterons personnellement sous deux jours ouvrés.",
    "err": "Cela n'a malheureusement pas fonctionné. Écrivez-nous directement à info@berlin-cube.de."
   }
  },
  "footer": {
   "claim": "Designed in Berlin. Built for Europe.",
   "impressum": "Mentions légales",
   "datenschutz": "Confidentialité"
  },
  "seo": {
   "title": "BERLIN-CUBE | Des zones de sécurité deviennent des lieux de vie.",
   "description": "De l’ombre, des arbres, de l’eau de pluie et des places assises pour les centres-villes qui surchauffent. Et en plus, une protection anti-véhicule testée lors d’un crash-test DEKRA. Un système modulaire, de nombreuses solutions."
  },
  "kantStatus": "De juin à septembre 2026. Posé sans fondation, démonté sans laisser de traces."
 },
 "pl": {
  "nav": [
   [
    "#loesungen",
    "Rozwiązania"
   ],
   [
    "#kombinieren",
    "Rozmiary"
   ],
   [
    "#nachweis",
    "Dowód"
   ],
   [
    "#anwendungen",
    "Zastosowania"
   ],
   [
    "#foerderung",
    "Finansowanie"
   ],
   [
    "#kontakt",
    "Kontakt"
   ]
  ],
  "cta": "Umów rozmowę",
  "badge": {
   "foto": "ZDJĘCIE",
   "video": "WIDEO",
   "vorf": "PREZENTACJA",
   "heute": "DZIŚ · ZDJĘCIE",
   "morgen": "JUTRO · WIZUALIZACJA",
   "vis": "WIZUALIZACJA",
   "bg": "TŁO: WIZUALIZACJA"
  },
  "hero": {
   "kicker": "INFRASTRUKTURA MIEJSKA DOSTOSOWANA DO KLIMATU",
   "h1a": "Ze stref bezpieczeństwa",
   "h1b": "powstają ",
   "h1c": "miejsca do życia.",
   "p": "Cień, drzewa, woda deszczowa i miejsca do siedzenia dla rozgrzanych centrów miast. A do tego ochrona przed wjazdem pojazdów, sprawdzona w teście zderzeniowym DEKRA. Jeden modułowy system, wiele rozwiązań.",
   "a": "Zobacz rozwiązania"
  },
  "facts": [
   [
    "1,44 m²",
    "zieleni na moduł"
   ],
   [
    "ok. 190 litrów",
    "retencji wody deszczowej na moduł „miasto-gąbka”, wg obliczeń"
   ],
   [
    "IWA 14-1",
    "Test zderzeniowy DEKRA · 7114 kg · 63,9 km/h"
   ],
   [
    "EP 3 486 374",
    "Patent europejski"
   ]
  ],
  "fuer": [
   "DLA",
   [
    "Miast i gmin",
    "Planowania przestrzennego i wydziałów zieleni",
    "Zarządców śródmieść i organizatorów wydarzeń",
    "Osiedli i inwestorów"
   ]
  ],
  "manifest": {
   "h2": "Przyzwyczailiśmy się do betonu.",
   "p1": "Do biało-czerwonych zapór przed kościołami. Do barierek przed każdym jarmarkiem bożonarodzeniowym. Do placów, które wyglądają jak place budowy.",
   "p2": "A przecież właśnie tam mogłoby stać drzewo. Ławka. Cień w upalny dzień.",
   "claim1": "Bezpieczeństwa nie trzeba widzieć.",
   "claim2": "Trzeba go doświadczać.",
   "alt": "Wejście na berliński jarmark z biało-czerwonymi zaporami i żółto-czarnymi płytami",
   "cap": "Jarmark bożonarodzeniowy na Breitscheidplatz w Berlinie."
  },
  "hm": {
   "kicker": "BREITSCHEIDPLATZ, BERLIN",
   "h2a": "To samo miejsce. ",
   "h2b": "Inne odczucie.",
   "heute": "Dziś",
   "morgen": "Jutro",
   "altH": "Breitscheidplatz dziś: betonowe zapory i namioty przed Kościołem Pamięci",
   "altM": "Breitscheidplatz jutro: Berlin-Cube z drzewami, ławkami i światłem przed Kościołem Pamięci",
   "capH": "Dziś: betonowe zapory, barierki i taśma przed Kościołem Pamięci. Bezpiecznie, ale nikt nie chce się tu zatrzymać.",
   "capM": "Jutro: to samo bezpieczeństwo, a do tego drzewa, ławki, światło i cień. Plac, na którym ludzie się spotykają."
  },
  "prinzip": {
   "kicker": "ZASADA",
   "h2a": "Jeden moduł.",
   "h2b": "Pięć zadań.",
   "p": "Zamiast betonowych bloków i słupków stoi moduł z ocynkowanej ogniowo stali, który chroni, a jednocześnie chłodzi, wprowadza zieleń i zaprasza do odpoczynku. Ustawiany bez fundamentu, demontowany bez śladu.",
   "alt": "Obsadzony lawendą Berlin-Cube na Kantstraße w Berlinie",
   "items": [
    [
     "Klimat i CO₂",
     "Drzewa i rośliny wiążą CO₂, dają cień i chłodzą dzięki parowaniu. Deszcz zostaje w podłożu zamiast trafiać do kanalizacji."
    ],
    [
     "Zieleń miejska",
     "Zieleń także na uszczelnionych placach i nad instalacjami podziemnymi, bez wykopu pod drzewo."
    ],
    [
     "Odpoczynek",
     "Usiąść, odetchnąć, zostać dłużej. Z oświetleniem wieczorem."
    ],
    [
     "Smart City",
     "Energia słoneczna, ładowanie, informacja: przygotowany jako platforma."
    ],
    [
     "Bezpieczeństwo",
     "Ochrona przed wjazdem, sprawdzona w teście zderzeniowym DEKRA wg IWA 14-1:2013."
    ]
   ]
  },
  "loesungen": {
   "kicker": "ROZWIĄZANIA",
   "h2a": "Jeden system bazowy.",
   "h2b": "Dziewięć odpowiedzi dla miasta.",
   "p": "Wszystkie warianty opierają się na sprawdzonym Cube i jego połączeniu linowym. Wyposażenie to koncepcje w fazie rozwoju. Do każdej istnieje szczegółowy PDF z rysunkami i opisem. Chętnie go Państwu prześlemy.",
   "feat": {
    "tag": "MIASTO-GĄBKA",
    "h3": "Deszcz, przestrzeń dla korzeni i miejsce odpoczynku w jednym module.",
    "alt": "Przekrój Cube miasto-gąbka ze zbiornikiem wody i korzeniami wrastającymi w grunt przez otwarte dno",
    "li": [
     "Wg obliczeń ok. 190 litrów retencji na moduł, plus dopływ z nawierzchni",
     "Otwarte dno: korzenie wrastają w grunt",
     "Drzewa na uszczelnionych placach",
     "Prąd, dane i woda przez planowany kanał techniczny"
    ],
    "cta": "Zamów koncepcję Miasto-gąbka"
   },
   "more": "Zamów koncepcję →",
   "cards": [
    [
     "baum",
     "Drzewo i cień",
     "Drzewa na nawierzchni i nad instalacjami, w trzech rozmiarach.",
     "Duży Cube z drzewem i ławką na placu"
    ],
    [
     "klima",
     "Klimat",
     "Chłodzenie gorących punktów: cień, parowanie, mgiełka wodna.",
     "Cube klimatyczne z żaglem nad miejscami do siedzenia"
    ],
    [
     "wasser",
     "Woda",
     "Poidełko i mgiełka wodna wbudowane w Cube.",
     "Mgiełka wodna między obsadzonymi Cube w upalny dzień"
    ],
    [
     "solar",
     "Słońce i ładowanie",
     "Własny prąd dla oświetlenia i rowerów elektrycznych, przyłącze sieciowe dla samochodów.",
     "Cube z dachem solarnym nad ławką"
    ],
    [
     "licht",
     "Światło",
     "Jasne, bezpieczne place wieczorem, sterowane czujnikami i przyjazne owadom.",
     "Podświetlone Cube wieczorem przed Kościołem Pamięci"
    ],
    [
     "bank",
     "Ławka",
     "Siedzenie i ochrona w jednym: ławka na trzech stalowych belkach HEB.",
     "Ławka między dwoma Cube z roślinami wieczorem"
    ],
    [
     "service",
     "Serwis i informacja",
     "Odpady, informacja miejska i reklama, wbudowane zamiast dostawione.",
     "Plac z Cube na odpady, informację i reklamę"
    ],
    [
     "mobil",
     "Mobilny",
     "Ochrona przed wjazdem, którą można otworzyć dla straży pożarnej, ratownictwa i dostaw.",
     "Ruchome Cube na kołach jako otwierana ochrona przed wjazdem"
    ]
   ],
   "note": "Wszystkie obrazy w tej sekcji to wizualizacje. Stan koncepcji: październik 2026."
  },
  "groessen": {
   "kicker": "ROZMIARY I KOMBINACJE",
   "h2a": "Z przodu ochrona.",
   "h2b": "Za nią cień.",
   "p1": "Sprawdzony rząd Cube’ów 1,20 m zabezpiecza wjazd. Za nim stoją większe Cube’y z drzewami dla cienia, chłodu i wiązania CO₂. Tak z zapory powstaje cały plac.",
   "p2": "Wszystkie rozmiary w tej samej konstrukcji i stylistyce, dowolnie łączone z ławką, światłem, wodą i energią słoneczną.",
   "sizes": [
    [
     "1,20 m",
     "Sprawdzony",
     72,
     72,
     "#141712"
    ],
    [
     "1,50 m",
     "W fazie rozwoju",
     90,
     90,
     "#3a4234"
    ],
    [
     "2,00 m",
     "W fazie rozwoju",
     120,
     120,
     "#5b6353"
    ],
    [
     "3,00 × 2,00 m",
     "W planach",
     180,
     120,
     null
    ],
    [
     "3,00 × 3,00 m",
     "W planach",
     180,
     180,
     null
    ]
   ],
   "note": "Powierzchnie podstawy w skali."
  },
  "vergleich": {
   "kicker": "PORÓWNANIE",
   "h2a": "Co potrafi zapora. ",
   "h2b": "A co potrafi Cube.",
   "head": [
    "Blok betonowy",
    "Słupek",
    "Berlin-Cube"
   ],
   "rows": [
    [
     "Ochrona przed wjazdem",
     "zależnie od produktu",
     "zależnie od produktu",
     "sprawdzony wg IWA 14-1"
    ],
    [
     "Zieleń miejska",
     "—",
     "—",
     "1,44 m² na moduł"
    ],
    [
     "Woda deszczowa",
     "—",
     "—",
     "zostaje w podłożu"
    ],
    [
     "Cień i chłodzenie",
     "—",
     "—",
     "z drzewem lub żaglem"
    ],
    [
     "Miejsca do siedzenia",
     "—",
     "—",
     "tak"
    ],
    [
     "Światło wieczorem",
     "—",
     "częściowo",
     "krawędzie LED w standardzie"
    ],
    [
     "Bez fundamentu",
     "tak",
     "zwykle nie",
     "tak"
    ],
    [
     "Wpływ na wygląd miasta",
     "strefa zamknięta",
     "zapora",
     "miejsce do odpoczynku"
    ]
   ]
  },
  "nachweis": {
   "kicker": "DOWÓD",
   "h2a": "Celowo",
   "h2b": "go staranowaliśmy.",
   "dl": [
    [
     "Norma",
     "IWA 14-1:2013"
    ],
    [
     "Pojazd",
     "7114 kg"
    ],
    [
     "Prędkość",
     "63,9 km/h"
    ],
    [
     "Strefa bezpieczna",
     "od 7,95 m za modułem"
    ],
    [
     "Raport z badania",
     "DEKRA nr 201844624"
    ]
   ],
   "note": "Sprawdzone są Cube i połączenie linowe. Następna generacja: test zderzeniowy wg ISO 22343-1 w planach."
  },
  "realisiert": {
   "kicker": "ZREALIZOWANE",
   "h2a": "Nie jutro. ",
   "h2b": "Dziś.",
   "all": "Zobacz wszystkie projekty →",
   "items": [
    [
     "video",
     "Wideo: podświetlone Berlin-Cube na Kantstraße o zachodzie słońca",
     "Pilotaż Kantstraße, Berlin",
     "Od czerwca do września 2026. Ustawiony bez fundamentu, zdemontowany bez śladu."
    ],
    [
     "foto",
     "Ławka z drewnianym siedziskiem przy obsadzonym Berlin-Cube na Kantstraße w dzień",
     "Siedzieć zamiast blokować",
     "Ławki, zieleń i ochrona przed wjazdem w jednym rzędzie."
    ],
    [
     "vorf",
     "Prezentacja trzech Berlin-Cube z rampą przy centrum outletowym w Wustermark",
     "Wustermark, Brandenburgia",
     "Prezentacja przy centrum outletowym: rampa, punkt ładowania, drzewo."
    ]
   ]
  },
  "ablauf": {
   "kicker": "TAK PRZEBIEGA PROJEKT",
   "h2a": "Wszystko z jednej ręki. ",
   "h2b": "W czterech krokach.",
   "steps": [
    [
     "Zapytanie",
     "Opisują nam Państwo swój plac i czego od niego oczekują."
    ],
    [
     "Lokalizacja i finansowanie",
     "Sprawdzamy miejsce i wskazujemy możliwe źródła finansowania."
    ],
    [
     "Projekt",
     "Układ, warianty, nasadzenia i oświetlenie dla Państwa placu."
    ],
    [
     "Dostawa i montaż",
     "Czas dostawy ok. 2–3 miesięcy, zależnie od liczby sztuk. Montaż bez fundamentu."
    ]
   ]
  },
  "anwendungen": {
   "kicker": "ZASTOSOWANIA",
   "h2a": "Od czego chcą ",
   "h2b": "Państwo zacząć?",
   "links": [
    [
     "/en/climate-adaptation-street-space",
     "Adaptacja do klimatu i ochrona przed upałem"
    ],
    [
     "/en/vehicle-security-barriers-pedestrian-zones",
     "Strefy piesze i centra miast"
    ],
    [
     "/en/vehicle-security-barriers-christmas-markets",
     "Jarmarki bożonarodzeniowe"
    ],
    [
     "/en/vehicle-barriers-events",
     "Wydarzenia i festyny miejskie"
    ],
    [
     "/en/vehicle-protection-cultural-venues",
     "Obiekty kultury i place"
    ],
    [
     "/en/vehicle-protection-government-buildings",
     "Urzędy i budynki publiczne"
    ]
   ]
  },
  "foerderung": {
   "kicker": "FINANSOWANIE",
   "h2a": "Jeden partner od ",
   "h2b": "rozwiązania i finansowania.",
   "p": "Adaptacja do klimatu, miasto-gąbka, zieleń miejska i jakość przestrzeni publicznej: na te cele istnieją źródła finansowania publicznego, krajowe i europejskie. Pomożemy znaleźć to, które pasuje do Państwa placu.",
   "cta": "Poproś o wstępną ocenę"
  },
  "presse": {
   "quote": "„To lepsze niż barykadowanie wszystkiego.”",
   "by": "Kirstin Bauch, burmistrz dzielnicy Charlottenburg-Wilmersdorf w Berlinie, w „Berliner Morgenpost” (tłum. z niemieckiego)",
   "kicker": "PISALI O NAS",
   "list": "rbb24 Abendschau · radio3 · Tagesspiegel · Berliner Morgenpost · Entwicklungsstadt Berlin"
  },
  "erfinder": {
   "kicker": "WYNALAZCA I PRODUCENT",
   "h2a": "Wymyślony w Berlinie.",
   "h2b": "Budowany w Brandenburgii.",
   "p1": "Martin Fichtelmann opracował Cube i chroni go patentem europejskim EP 3 486 374. Jako architekt krajobrazu wie, czego potrzebują rośliny na miejskim placu, i buduje Cube w Wustermark pod Berlinem.",
   "p2": "Jeden partner od pierwszego pomysłu po pielęgnację.",
   "alt": "Martin Fichtelmann, Erfinder des Berlin-Cube, am Breitscheidplatz in Berlin"
  },
  "kontakt": {
   "kicker": "KONTAKT",
   "h2a": "Wyobraźcie sobie Państwo swój plac",
   "h2b": "za rok.",
   "p": "Pokażemy, jak może wyglądać. I jak go sfinansować.",
   "p2": "Napiszcie nam krótko: gdzie i co. Otrzymają Państwo wybrane materiały e-mailem oraz naszą wstępną ocenę z możliwymi źródłami finansowania.",
   "addr": "Berliner Allee 37–39, 14641 Wustermark, Niemcy",
   "f": {
    "name": "Imię i nazwisko",
    "org": "Miasto, gmina lub organizacja",
    "email": "E-mail",
    "ort": "Rodzaj miejsca",
    "orte": [
     "Plac lub strefa piesza",
     "Jarmark lub wydarzenie",
     "Gorący punkt lub adaptacja do klimatu",
     "Obiekt kultury lub urząd",
     "Inne"
    ],
    "laenge": "Przybliżona długość w metrach",
    "msg": "Wiadomość",
    "legend": "Jakie materiały możemy Państwu przesłać?",
    "docs": [
     [
      "foerderleitfaden",
      "Przewodnik po finansowaniu (po niemiecku)"
     ],
     [
      "schwammstadt",
      "Miasto-gąbka"
     ],
     [
      "baum",
      "Drzewo i cień"
     ],
     [
      "klima",
      "Klimat"
     ],
     [
      "wasser",
      "Woda"
     ],
     [
      "solar",
      "Słońce i ładowanie"
     ],
     [
      "licht",
      "Światło"
     ],
     [
      "bank",
      "Ławka"
     ],
     [
      "service",
      "Serwis i informacja"
     ],
     [
      "mobil",
      "Mobilny"
     ]
    ],
    "hint1": "Państwa dane wykorzystujemy wyłącznie do odpowiedzi na zapytanie. Więcej w ",
    "hintLink": "polityce prywatności",
    "hint2": ".",
    "submit": "Wyślij zapytanie i otrzymaj materiały",
    "sending": "Wysyłanie …",
    "ok": "Dziękujemy! Skontaktujemy się z Państwem osobiście w ciągu dwóch dni roboczych.",
    "err": "Niestety nie udało się wysłać. Prosimy napisać bezpośrednio na info@berlin-cube.de."
   }
  },
  "footer": {
   "claim": "Designed in Berlin. Built for Europe.",
   "impressum": "Nota prawna",
   "datenschutz": "Prywatność"
  },
  "seo": {
   "title": "BERLIN-CUBE | Ze stref bezpieczeństwa powstają miejsca do życia.",
   "description": "Cień, drzewa, woda deszczowa i miejsca do siedzenia dla rozgrzanych centrów miast. A do tego ochrona przed wjazdem pojazdów, sprawdzona w teście zderzeniowym DEKRA. Jeden modułowy system, wiele rozwiązań."
  },
  "kantStatus": "Od czerwca do września 2026. Ustawiony bez fundamentu, zdemontowany bez śladu."
 },
 "es": {
  "nav": [
   [
    "#loesungen",
    "Soluciones"
   ],
   [
    "#kombinieren",
    "Tamaños"
   ],
   [
    "#nachweis",
    "Ensayo"
   ],
   [
    "#anwendungen",
    "Usos"
   ],
   [
    "#foerderung",
    "Financiación"
   ],
   [
    "#kontakt",
    "Contacto"
   ]
  ],
  "cta": "Solicitar una reunión",
  "badge": {
   "foto": "FOTO",
   "video": "VÍDEO",
   "vorf": "DEMOSTRACIÓN",
   "heute": "HOY · FOTO",
   "morgen": "MAÑANA · VISUALIZACIÓN",
   "vis": "VISUALIZACIÓN",
   "bg": "FONDO: VISUALIZACIÓN"
  },
  "hero": {
   "kicker": "INFRAESTRUCTURA URBANA ADAPTADA AL CLIMA",
   "h1a": "De zonas de seguridad",
   "h1b": "a ",
   "h1c": "espacios de vida.",
   "p": "Sombra, árboles, agua de lluvia y asientos para centros urbanos que se recalientan. Y, además, una protección antiintrusión de vehículos ensayada en un crash test de DEKRA. Un sistema modular, muchas soluciones.",
   "a": "Ver soluciones"
  },
  "facts": [
   [
    "1,44 m²",
    "de vegetación por módulo"
   ],
   [
    "unos 190 litros",
    "de almacenamiento de agua de lluvia por módulo «ciudad esponja», según cálculo"
   ],
   [
    "IWA 14-1",
    "Crash test DEKRA · 7.114 kg · 63,9 km/h"
   ],
   [
    "EP 3 486 374",
    "Patente europea"
   ]
  ],
  "fuer": [
   "PARA",
   [
    "Ciudades y municipios",
    "Urbanismo y servicios de parques y jardines",
    "Gestión de centros urbanos y organizadores de eventos",
    "Barrios e inversores"
   ]
  ],
  "manifest": {
   "h2": "Nos hemos acostumbrado al hormigón.",
   "p1": "A las barreras rojas y blancas delante de las iglesias. A las vallas delante de cada mercado navideño. A plazas que parecen obras.",
   "p2": "Y, sin embargo, justo ahí podría haber un árbol. Un banco. Sombra en un día caluroso.",
   "claim1": "La seguridad no tiene por qué verse.",
   "claim2": "Tiene que vivirse.",
   "alt": "Entrada de un mercado navideño berlinés con barreras rojas y blancas y placas de suelo amarillas y negras",
   "cap": "Mercado navideño en la Breitscheidplatz, Berlín."
  },
  "hm": {
   "kicker": "BREITSCHEIDPLATZ, BERLÍN",
   "h2a": "El mismo lugar. ",
   "h2b": "Otra sensación.",
   "heute": "Hoy",
   "morgen": "Mañana",
   "altH": "La Breitscheidplatz hoy: bloques de hormigón y carpas delante de la Iglesia Memorial Kaiser Wilhelm",
   "altM": "La Breitscheidplatz mañana: Berlin-Cubes con árboles, bancos y luz delante de la Iglesia Memorial Kaiser Wilhelm",
   "capH": "Hoy: bloques de hormigón, vallas y cinta de balizamiento delante de la Iglesia Memorial Kaiser Wilhelm. Es seguro, pero nadie quiere detenerse allí.",
   "capM": "Mañana: la misma seguridad, con árboles, bancos, luz y sombra. Una plaza donde la gente se encuentra."
  },
  "prinzip": {
   "kicker": "EL PRINCIPIO",
   "h2a": "Un módulo.",
   "h2b": "Cinco funciones.",
   "p": "En lugar de bloques de hormigón y bolardos: un módulo de acero galvanizado en caliente que protege y, al mismo tiempo, refresca, aporta vegetación e invita a quedarse. Se instala sin cimentación y se retira sin dejar rastro.",
   "alt": "Berlin-Cube plantado con lavanda en la Kantstraße, Berlín",
   "items": [
    [
     "Clima y CO₂",
     "Los árboles y las plantas fijan CO₂, dan sombra y refrescan mediante evapotranspiración. La lluvia se queda en el sustrato en lugar de ir al alcantarillado."
    ],
    [
     "Vegetación urbana",
     "Vegetación incluso en plazas impermeabilizadas y sobre redes de servicios, sin alcorque."
    ],
    [
     "Estancia",
     "Sentarse, respirar, quedarse. Con luz por la noche."
    ],
    [
     "Ciudad inteligente",
     "Solar, carga, información: preparado como plataforma."
    ],
    [
     "Seguridad",
     "Protección antiintrusión de vehículos, ensayada en un crash test de DEKRA según IWA 14-1:2013."
    ]
   ]
  },
  "loesungen": {
   "kicker": "LAS SOLUCIONES",
   "h2a": "Un sistema base.",
   "h2b": "Nueve respuestas para la ciudad.",
   "p": "Todas las variantes se basan en el Cube ensayado y su unión por cable. Los equipamientos son conceptos en desarrollo. Para cada uno existe un PDF detallado con planos y explicaciones. Se lo enviamos con mucho gusto.",
   "feat": {
    "tag": "CIUDAD ESPONJA",
    "h3": "Lluvia, espacio radicular y lugar de estancia en un solo módulo.",
    "alt": "Sección de un Cube ciudad esponja con depósito de agua y raíces que crecen hacia el terreno a través del fondo abierto",
    "li": [
     "Unos 190 litros de almacenamiento por módulo según cálculo, más el agua recogida del pavimento",
     "Fondo abierto: las raíces crecen hacia el terreno",
     "Árboles en plazas impermeabilizadas",
     "Electricidad, datos y agua a través de una canaleta técnica prevista"
    ],
    "cta": "Solicitar el concepto Ciudad esponja"
   },
   "more": "Solicitar el concepto →",
   "cards": [
    [
     "baum",
     "Árbol y sombra",
     "Árboles sobre pavimento y sobre redes de servicios, en tres tamaños.",
     "Gran Cube con árbol y banco en una plaza urbana"
    ],
    [
     "klima",
     "Clima",
     "Refrescar las islas de calor: sombra, evaporación, nebulización.",
     "Cubes climáticos con toldo vela sobre los asientos"
    ],
    [
     "wasser",
     "Agua",
     "Fuente de agua potable y nebulización, integradas en el Cube.",
     "Nebulización entre Cubes plantados en un día de calor"
    ],
    [
     "solar",
     "Solar y carga",
     "Electricidad propia para la iluminación y las bicicletas eléctricas, conexión a la red para coches.",
     "Cube con cubierta solar sobre un banco"
    ],
    [
     "licht",
     "Luz",
     "Plazas iluminadas y seguras por la noche, con control por sensores y respetuosas con los insectos.",
     "Cubes iluminados por la noche delante de la Iglesia Memorial Kaiser Wilhelm"
    ],
    [
     "bank",
     "Banco",
     "Sentarse y proteger a la vez: un banco sobre tres vigas de acero HEB.",
     "Banco entre dos Cubes plantados por la noche"
    ],
    [
     "service",
     "Servicios e información",
     "Residuos, información urbana y publicidad, integrados en lugar de añadidos.",
     "Plaza con Cubes para residuos, información y publicidad"
    ],
    [
     "mobil",
     "Móvil",
     "Una protección antiintrusión de vehículos que se abre para bomberos, servicios de emergencia y reparto.",
     "Cubes móviles sobre ruedas como protección antiintrusión que se puede abrir"
    ]
   ],
   "note": "Todas las imágenes de esta sección son visualizaciones. Estado de los conceptos: octubre de 2026."
  },
  "groessen": {
   "kicker": "TAMAÑOS Y COMBINACIONES",
   "h2a": "Delante, protección.",
   "h2b": "Detrás, sombra.",
   "p1": "Una hilera ensayada de Cubes de 1,20 m protege el acceso. Detrás se sitúan Cubes más grandes con árboles para dar sombra, refrescar y fijar CO₂. Así, una barrera se convierte en una plaza completa.",
   "p2": "Todos los tamaños con la misma construcción y el mismo diseño, combinables libremente con banco, luz, agua y solar.",
   "sizes": [
    [
     "1,20 m",
     "Ensayado",
     72,
     72,
     "#141712"
    ],
    [
     "1,50 m",
     "En desarrollo",
     90,
     90,
     "#3a4234"
    ],
    [
     "2,00 m",
     "En desarrollo",
     120,
     120,
     "#5b6353"
    ],
    [
     "3,00 × 2,00 m",
     "En proyecto",
     180,
     120,
     null
    ],
    [
     "3,00 × 3,00 m",
     "En proyecto",
     180,
     180,
     null
    ]
   ],
   "note": "Superficies en planta representadas a escala."
  },
  "vergleich": {
   "kicker": "LA COMPARACIÓN",
   "h2a": "Lo que hace una barrera. ",
   "h2b": "Y lo que hace un Cube.",
   "head": [
    "Bloque de hormigón",
    "Bolardo",
    "Berlin-Cube"
   ],
   "rows": [
    [
     "Protección antiintrusión",
     "según el producto",
     "según el producto",
     "ensayado según IWA 14-1"
    ],
    [
     "Vegetación urbana",
     "—",
     "—",
     "1,44 m² por módulo"
    ],
    [
     "Agua de lluvia",
     "—",
     "—",
     "se queda en el sustrato"
    ],
    [
     "Sombra y frescor",
     "—",
     "—",
     "con árbol o toldo vela"
    ],
    [
     "Asientos",
     "—",
     "—",
     "sí"
    ],
    [
     "Luz por la noche",
     "—",
     "a veces",
     "bordes LED de serie"
    ],
    [
     "Sin cimentación",
     "sí",
     "casi nunca",
     "sí"
    ],
    [
     "Efecto en el paisaje urbano",
     "zona prohibida",
     "barrera",
     "lugar para quedarse"
    ]
   ]
  },
  "nachweis": {
   "kicker": "EL ENSAYO",
   "h2a": "Lo embestimos",
   "h2b": "a propósito.",
   "dl": [
    [
     "Norma",
     "IWA 14-1:2013"
    ],
    [
     "Vehículo",
     "7.114 kg"
    ],
    [
     "Velocidad",
     "63,9 km/h"
    ],
    [
     "Zona segura",
     "a partir de 7,95 m detrás del módulo"
    ],
    [
     "Informe de ensayo",
     "DEKRA n.º 201844624"
    ]
   ],
   "note": "Se han ensayado el Cube y su unión por cable. Próxima generación: crash test según ISO 22343-1 en preparación."
  },
  "realisiert": {
   "kicker": "REALIZADO",
   "h2a": "No mañana. ",
   "h2b": "Hoy.",
   "all": "Ver todos los proyectos →",
   "items": [
    [
     "video",
     "Vídeo: Berlin-Cubes iluminados en la Kantstraße al atardecer",
     "Proyecto piloto Kantstraße, Berlín",
     "De junio a septiembre de 2026. Instalado sin cimentación, retirado sin dejar rastro."
    ],
    [
     "foto",
     "Banco con asiento de madera en un Berlin-Cube plantado en la Kantstraße, de día",
     "Sentarse en lugar de bloquear",
     "Bancos, vegetación y protección antiintrusión en una misma hilera."
    ],
    [
     "vorf",
     "Demostración de tres Berlin-Cubes con rampa ante un outlet en Wustermark",
     "Wustermark, Brandeburgo",
     "Demostración ante un outlet: rampa, punto de carga, árbol."
    ]
   ]
  },
  "ablauf": {
   "kicker": "ASÍ SE DESARROLLA UN PROYECTO",
   "h2a": "Un solo interlocutor. ",
   "h2b": "En cuatro pasos.",
   "steps": [
    [
     "Solicitud",
     "Usted nos indica su emplazamiento y lo que debe aportar."
    ],
    [
     "Emplazamiento y financiación",
     "Analizamos el lugar e identificamos las vías de financiación posibles."
    ],
    [
     "Diseño",
     "Disposición, variantes, plantación e iluminación para su emplazamiento."
    ],
    [
     "Entrega e instalación",
     "Plazo de entrega de unos 2 a 3 meses según el número de unidades. Instalación sin cimentación."
    ]
   ]
  },
  "anwendungen": {
   "kicker": "USOS",
   "h2a": "¿Por dónde quiere ",
   "h2b": "empezar?",
   "links": [
    [
     "/en/climate-adaptation-street-space",
     "Adaptación climática y protección frente al calor"
    ],
    [
     "/en/vehicle-security-barriers-pedestrian-zones",
     "Zonas peatonales y centros urbanos"
    ],
    [
     "/en/vehicle-security-barriers-christmas-markets",
     "Mercados navideños"
    ],
    [
     "/en/vehicle-barriers-events",
     "Eventos y fiestas locales"
    ],
    [
     "/en/vehicle-protection-cultural-venues",
     "Espacios culturales y plazas"
    ],
    [
     "/en/vehicle-protection-government-buildings",
     "Administraciones y edificios públicos"
    ]
   ]
  },
  "foerderung": {
   "kicker": "FINANCIACIÓN",
   "h2a": "Un solo interlocutor para ",
   "h2b": "la solución y su financiación.",
   "p": "Adaptación climática, ciudad esponja, vegetación urbana y calidad del espacio público: estos ámbitos pueden optar a financiación pública, nacional o europea. Le ayudamos a identificar la vía adecuada para su emplazamiento.",
   "cta": "Solicitar una primera valoración"
  },
  "presse": {
   "quote": "«Es mejor que blindarlo todo con barricadas.»",
   "by": "Kirstin Bauch, alcaldesa del distrito de Charlottenburg-Wilmersdorf (Berlín), en el Berliner Morgenpost (traducido del alemán)",
   "kicker": "HAN HABLADO DE NOSOTROS",
   "list": "rbb24 Abendschau · radio3 · Tagesspiegel · Berliner Morgenpost · Entwicklungsstadt Berlin"
  },
  "erfinder": {
   "kicker": "INVENTOR Y FABRICANTE",
   "h2a": "Inventado en Berlín.",
   "h2b": "Fabricado en Brandeburgo.",
   "p1": "Martin Fichtelmann desarrolló el Cube y lo protegió con la patente europea EP 3 486 374. Como paisajista de profesión, sabe lo que necesitan las plantas en una plaza urbana, y fabrica el Cube en Wustermark, cerca de Berlín.",
   "p2": "Un solo interlocutor, desde la primera idea hasta el mantenimiento.",
   "alt": "Martin Fichtelmann, Erfinder des Berlin-Cube, am Breitscheidplatz in Berlin"
  },
  "kontakt": {
   "kicker": "CONTACTO",
   "h2a": "Imagine su plaza",
   "h2b": "dentro de un año.",
   "p": "Le mostramos cómo puede ser. Y cómo financiarla.",
   "p2": "Indíquenos brevemente dónde y qué. Recibirá por correo electrónico la documentación solicitada y, de nuestra parte, una primera valoración con las vías de financiación posibles.",
   "addr": "Berliner Allee 37–39, 14641 Wustermark, Alemania",
   "f": {
    "name": "Nombre",
    "org": "Ciudad, municipio u organización",
    "email": "Correo electrónico",
    "ort": "Tipo de lugar",
    "orte": [
     "Plaza o zona peatonal",
     "Mercado navideño o evento",
     "Isla de calor o adaptación climática",
     "Espacio cultural o administración",
     "Otro"
    ],
    "laenge": "Longitud aproximada en metros",
    "msg": "Mensaje",
    "legend": "¿Qué documentación podemos enviarle?",
    "docs": [
     [
      "foerderleitfaden",
      "Guía de financiación (en alemán)"
     ],
     [
      "schwammstadt",
      "Ciudad esponja"
     ],
     [
      "baum",
      "Árbol y sombra"
     ],
     [
      "klima",
      "Clima"
     ],
     [
      "wasser",
      "Agua"
     ],
     [
      "solar",
      "Solar y carga"
     ],
     [
      "licht",
      "Luz"
     ],
     [
      "bank",
      "Banco"
     ],
     [
      "service",
      "Servicios e información"
     ],
     [
      "mobil",
      "Móvil"
     ]
    ],
    "hint1": "Utilizamos sus datos únicamente para responder a su solicitud. Más información en la ",
    "hintLink": "política de privacidad",
    "hint2": ".",
    "submit": "Enviar solicitud y recibir documentación",
    "sending": "Enviando …",
    "ok": "¡Gracias! Nos pondremos en contacto con usted personalmente en un plazo de dos días laborables.",
    "err": "No ha funcionado. Escríbanos directamente a info@berlin-cube.de."
   }
  },
  "footer": {
   "claim": "Designed in Berlin. Built for Europe.",
   "impressum": "Aviso legal",
   "datenschutz": "Privacidad"
  },
  "seo": {
   "title": "BERLIN-CUBE | De zonas de seguridad a espacios de vida.",
   "description": "Sombra, árboles, agua de lluvia y asientos para centros urbanos que se recalientan. Y, además, una protección antiintrusión de vehículos ensayada en un crash test de DEKRA. Un sistema modular, muchas soluciones."
  },
  "kantStatus": "De junio a septiembre de 2026. Instalado sin cimentación, retirado sin dejar rastro."
 },
 "uk": {
  "nav": [
   [
    "#loesungen",
    "Рішення"
   ],
   [
    "#kombinieren",
    "Розміри"
   ],
   [
    "#nachweis",
    "Доказ"
   ],
   [
    "#anwendungen",
    "Застосування"
   ],
   [
    "#foerderung",
    "Фінансування"
   ],
   [
    "#kontakt",
    "Контакт"
   ]
  ],
  "cta": "Зв’язатися з нами",
  "badge": {
   "foto": "ФОТО",
   "video": "ВІДЕО",
   "vorf": "ДЕМОНСТРАЦІЯ",
   "heute": "СЬОГОДНІ · ФОТО",
   "morgen": "ЗАВТРА · ВІЗУАЛІЗАЦІЯ",
   "vis": "ВІЗУАЛІЗАЦІЯ",
   "bg": "ФОН: ВІЗУАЛІЗАЦІЯ"
  },
  "hero": {
   "kicker": "КЛІМАТИЧНО АДАПТОВАНА МІСЬКА ІНФРАСТРУКТУРА",
   "h1a": "Зони безпеки",
   "h1b": "стають ",
   "h1c": "просторами для життя.",
   "p": "Тінь, дерева, дощова вода та місця для сидіння для спекотних центрів міст. А ще захист від проїзду транспорту, випробуваний у краш-тесті DEKRA. Одна модульна система, багато рішень.",
   "a": "Переглянути рішення"
  },
  "facts": [
   [
    "1,44 m²",
    "озеленення на модуль"
   ],
   [
    "близько 190 літрів",
    "накопичення дощової води на модуль «місто-губка», за розрахунком"
   ],
   [
    "IWA 14-1",
    "Краш-тест DEKRA · 7114 кг · 63,9 км/год"
   ],
   [
    "EP 3 486 374",
    "Європейський патент"
   ]
  ],
  "fuer": [
   "ДЛЯ",
   [
    "Міста і громади",
    "Містобудування та служби озеленення",
    "Сітименеджмент і організатори заходів",
    "Квартали та інвестори"
   ]
  ],
  "manifest": {
   "h2": "Ми звикли до бетону.",
   "p1": "До червоно-білих бар’єрів перед церквами. До огорож перед кожним різдвяним ярмарком. До площ, що виглядають як будівельні майданчики.",
   "p2": "А саме там могло б стояти дерево. Лавка. Тінь у спекотний день.",
   "claim1": "Безпеку не обов’язково бачити.",
   "claim2": "Її потрібно відчувати.",
   "alt": "Вхід на берлінський різдвяний ярмарок із червоно-білими бар’єрами та жовто-чорними плитами на землі",
   "cap": "Різдвяний ярмарок на Брайтшайдплац, Берлін."
  },
  "hm": {
   "kicker": "БРАЙТШАЙДПЛАЦ, БЕРЛІН",
   "h2a": "Те саме місце. ",
   "h2b": "Інше відчуття.",
   "heute": "Сьогодні",
   "morgen": "Завтра",
   "altH": "Брайтшайдплац сьогодні: бетонні бар’єри та намети перед Меморіальною церквою",
   "altM": "Брайтшайдплац завтра: Berlin-Cubes із деревами, лавками та світлом перед Меморіальною церквою",
   "capH": "Сьогодні: бетонні бар’єри, огорожі та сигнальна стрічка перед Меморіальною церквою. Безпечно, але ніхто не хоче тут затримуватися.",
   "capM": "Завтра: та сама безпека, а ще дерева, лавки, світло й тінь. Площа, де люди зустрічаються."
  },
  "prinzip": {
   "kicker": "ПРИНЦИП",
   "h2a": "Один модуль.",
   "h2b": "П’ять завдань.",
   "p": "Замість бетонних блоків і стовпчиків – модуль із гарячеоцинкованої сталі, який захищає і водночас охолоджує, озеленює та запрошує затриматися. Встановлюється без фундаменту, демонтується без жодних слідів.",
   "alt": "Berlin-Cube, засаджений лавандою, на Кантштрасе, Берлін",
   "items": [
    [
     "Клімат і CO₂",
     "Дерева й рослини поглинають CO₂, дають тінь і охолоджують завдяки випаровуванню. Дощова вода залишається в субстраті, а не йде в каналізацію."
    ],
    [
     "Міська зелень",
     "Зелень навіть на запечатаних площах і над комунікаціями, без посадкової ями."
    ],
    [
     "Відпочинок",
     "Сісти, перевести подих, затриматися. Зі світлом увечері."
    ],
    [
     "Smart City",
     "Сонячна енергія, зарядка, інформація: підготовлено як платформу."
    ],
    [
     "Безпека",
     "Захист від проїзду транспорту, випробуваний у краш-тесті DEKRA за IWA 14-1:2013."
    ]
   ]
  },
  "loesungen": {
   "kicker": "РІШЕННЯ",
   "h2a": "Одна базова система.",
   "h2b": "Дев’ять відповідей для міста.",
   "p": "Усі варіанти базуються на випробуваному Cube та його тросовому з’єднанні. Комплектації – це концепції в розробці. Для кожної є детальний PDF-файл із кресленнями та поясненнями. Ми охоче надішлемо його Вам.",
   "feat": {
    "tag": "МІСТО-ГУБКА",
    "h3": "Дощ, простір для коренів і відпочинок в одному модулі.",
    "alt": "Розріз Cube «місто-губка» з резервуаром для води та корінням, що проростає в ґрунт через відкрите дно",
    "li": [
     "За розрахунком близько 190 літрів накопичення на модуль, а також стік із бруківки",
     "Відкрите дно: коріння проростає в ґрунт",
     "Дерева на запечатаних площах",
     "Електрика, дані й вода через запланований технічний лоток"
    ],
    "cta": "Запросити концепцію «Місто-губка»"
   },
   "more": "Запросити концепцію →",
   "cards": [
    [
     "baum",
     "Дерево і тінь",
     "Дерева на бруківці та над комунікаціями, у трьох розмірах.",
     "Великий Cube з деревом і лавкою на міській площі"
    ],
    [
     "klima",
     "Клімат",
     "Охолодження для теплових острівців: тінь, випаровування, водяний туман.",
     "Кліматичні Cubes із тентом над місцями для сидіння"
    ],
    [
     "wasser",
     "Вода",
     "Питний фонтанчик і водяний туман, вбудовані в Cube.",
     "Водяний туман між засадженими Cubes у спекотний день"
    ],
    [
     "solar",
     "Сонце і зарядка",
     "Власна електроенергія для освітлення та електровелосипедів, підключення до мережі для автомобілів.",
     "Cube із сонячним дахом над лавкою"
    ],
    [
     "licht",
     "Світло",
     "Світлі й безпечні площі ввечері, з керуванням за датчиками та безпечне для комах.",
     "Підсвічені Cubes увечері перед Меморіальною церквою"
    ],
    [
     "bank",
     "Лавка",
     "Сидіння і захист в одному: лавка на трьох сталевих балках HEB.",
     "Лавка між двома Cubes із рослинами ввечері"
    ],
    [
     "service",
     "Сервіс та інформація",
     "Сміття, міська інформація та реклама – вбудовані, а не поставлені поруч.",
     "Площа з Cubes для сміття, інформації та реклами"
    ],
    [
     "mobil",
     "Мобільний",
     "Захист від проїзду, який можна відкрити для пожежників, рятувальників і транспорту доставки.",
     "Рухомі Cubes на колесах як захист від проїзду, що відкривається"
    ]
   ],
   "note": "Усі зображення в цьому розділі є візуалізаціями. Стан концепцій: жовтень 2026 року."
  },
  "groessen": {
   "kicker": "РОЗМІРИ ТА КОМБІНАЦІЇ",
   "h2a": "Попереду – захист.",
   "h2b": "Позаду – тінь.",
   "p1": "Випробуваний захисний ряд із Cube розміром 1,20 м убезпечує проїзд. Позаду стоять більші Cube з деревами для тіні, охолодження та поглинання CO₂. Так огородження перетворюється на повноцінну площу.",
   "p2": "Усі розміри мають однакову конструкцію та вигляд і вільно поєднуються з лавкою, світлом, водою та сонячними панелями.",
   "sizes": [
    [
     "1,20 m",
     "Випробувано",
     72,
     72,
     "#141712"
    ],
    [
     "1,50 m",
     "У розробці",
     90,
     90,
     "#3a4234"
    ],
    [
     "2,00 m",
     "У розробці",
     120,
     120,
     "#5b6353"
    ],
    [
     "3,00 × 2,00 m",
     "Заплановано",
     180,
     120,
     null
    ],
    [
     "3,00 × 3,00 m",
     "Заплановано",
     180,
     180,
     null
    ]
   ],
   "note": "Площі основи показано в масштабі."
  },
  "vergleich": {
   "kicker": "ПОРІВНЯННЯ",
   "h2a": "Що вміє бар’єр. ",
   "h2b": "І що вміє Cube.",
   "head": [
    "Бетонний блок",
    "Стовпчик",
    "Berlin-Cube"
   ],
   "rows": [
    [
     "Захист від проїзду",
     "залежно від продукту",
     "залежно від продукту",
     "випробувано за IWA 14-1"
    ],
    [
     "Міська зелень",
     "—",
     "—",
     "1,44 м² на модуль"
    ],
    [
     "Дощова вода",
     "—",
     "—",
     "залишається в субстраті"
    ],
    [
     "Тінь і охолодження",
     "—",
     "—",
     "з деревом або тентом"
    ],
    [
     "Місця для сидіння",
     "—",
     "—",
     "так"
    ],
    [
     "Світло ввечері",
     "—",
     "частково",
     "LED-контури серійно"
    ],
    [
     "Без фундаменту",
     "так",
     "зазвичай ні",
     "так"
    ],
    [
     "Вплив на міський простір",
     "заборонена зона",
     "бар’єр",
     "місце для відпочинку"
    ]
   ]
  },
  "nachweis": {
   "kicker": "ДОКАЗ",
   "h2a": "Ми його",
   "h2b": "навмисно протаранили.",
   "dl": [
    [
     "Норма",
     "IWA 14-1:2013"
    ],
    [
     "Транспортний засіб",
     "7114 кг"
    ],
    [
     "Швидкість",
     "63,9 km/h"
    ],
    [
     "Безпечна зона",
     "від 7,95 м за модулем"
    ],
    [
     "Протокол випробування",
     "DEKRA № 201844624"
    ]
   ],
   "note": "Випробувано Cube і тросове з’єднання. Наступне покоління: краш-тест за ISO 22343-1 у плані."
  },
  "realisiert": {
   "kicker": "РЕАЛІЗОВАНО",
   "h2a": "Не завтра. ",
   "h2b": "Сьогодні.",
   "all": "Усі проєкти →",
   "items": [
    [
     "video",
     "Відео: підсвічені Berlin-Cubes на Кантштрасе під час заходу сонця",
     "Пілотний проєкт Кантштрасе, Берлін",
     "З червня по вересень 2026 року. Встановлено без фундаменту, демонтовано без жодних слідів."
    ],
    [
     "foto",
     "Лавка з дерев’яним сидінням біля озелененого Berlin-Cube на Кантштрасе вдень",
     "Сидіти, а не перегороджувати",
     "Лавки, зелень і захист від проїзду в одному ряду."
    ],
    [
     "vorf",
     "Демонстрація трьох Berlin-Cubes із пандусом біля аутлет-центру у Вустермарку",
     "Вустермарк, Бранденбург",
     "Демонстрація біля аутлет-центру: пандус, зарядна станція, дерево."
    ]
   ]
  },
  "ablauf": {
   "kicker": "ЯК ПРОХОДИТЬ ПРОЄКТ",
   "h2a": "Усе з одних рук. ",
   "h2b": "У чотири кроки.",
   "steps": [
    [
     "Запит",
     "Ви розповідаєте нам про Вашу площу і що вона має давати."
    ],
    [
     "Місце і фінансування",
     "Ми оцінюємо місце і показуємо, яке фінансування підходить."
    ],
    [
     "Планування",
     "Розташування, варіанти, озеленення та освітлення для Вашої площі."
    ],
    [
     "Постачання і встановлення",
     "Строк постачання – приблизно 2–3 місяці залежно від кількості. Встановлення без фундаменту."
    ]
   ]
  },
  "anwendungen": {
   "kicker": "ЗАСТОСУВАННЯ",
   "h2a": "З чого Ви хочете ",
   "h2b": "почати?",
   "links": [
    [
     "/en/climate-adaptation-street-space",
     "Адаптація до клімату і захист від спеки"
    ],
    [
     "/en/vehicle-security-barriers-pedestrian-zones",
     "Пішохідні зони та центри міст"
    ],
    [
     "/en/vehicle-security-barriers-christmas-markets",
     "Різдвяні ярмарки"
    ],
    [
     "/en/vehicle-barriers-events",
     "Заходи та міські свята"
    ],
    [
     "/en/vehicle-protection-cultural-venues",
     "Культурні об’єкти та площі"
    ],
    [
     "/en/vehicle-protection-government-buildings",
     "Адміністрації та громадські будівлі"
    ]
   ]
  },
  "foerderung": {
   "kicker": "ФІНАНСУВАННЯ",
   "h2a": "Один контакт для ",
   "h2b": "рішення і фінансування.",
   "p": "Адаптація до клімату, місто-губка, озеленення та якість громадського простору: на ці цілі можна залучити державне фінансування – національне чи європейське. Ми допоможемо знайти шлях, який підходить для Вашої площі.",
   "cta": "Запросити першу оцінку"
  },
  "presse": {
   "quote": "«Це краще, ніж усе барикадувати».",
   "by": "Кірстін Баух, мер району Шарлоттенбург-Вільмерсдорф (Берлін), у Berliner Morgenpost (переклад з німецької)",
   "kicker": "ПРО НАС ПИСАЛИ",
   "list": "rbb24 Abendschau · radio3 · Tagesspiegel · Berliner Morgenpost · Entwicklungsstadt Berlin"
  },
  "erfinder": {
   "kicker": "ВИНАХІДНИК І ВИРОБНИК",
   "h2a": "Винайдено в Берліні.",
   "h2b": "Виготовлено в Бранденбурзі.",
   "p1": "Мартін Фіхтельманн розробив Cube і захистив його європейським патентом EP 3 486 374. Як фахівець із садово-паркового будівництва він знає, що потрібно рослинам на міській площі, і виготовляє Cube у Вустермарку поблизу Берліна.",
   "p2": "Один контакт – від першої ідеї до догляду.",
   "alt": "Martin Fichtelmann, Erfinder des Berlin-Cube, am Breitscheidplatz in Berlin"
  },
  "kontakt": {
   "kicker": "КОНТАКТ",
   "h2a": "Уявіть Вашу площу",
   "h2b": "через рік.",
   "p": "Ми покажемо Вам, як вона може виглядати. І як її профінансувати.",
   "p2": "Коротко напишіть нам, де і що. Ви отримаєте потрібні документи електронною поштою, а також нашу першу оцінку з можливими шляхами фінансування.",
   "addr": "Berliner Allee 37–39, 14641 Wustermark, Німеччина",
   "f": {
    "name": "Ім’я",
    "org": "Місто, громада чи організація",
    "email": "E-mail",
    "ort": "Тип місця",
    "orte": [
     "Площа чи пішохідна зона",
     "Різдвяний ярмарок чи захід",
     "Тепловий острівець чи адаптація до клімату",
     "Культурний об’єкт чи адміністрація",
     "Інше"
    ],
    "laenge": "Приблизна довжина в метрах",
    "msg": "Повідомлення",
    "legend": "Які документи ми можемо Вам надіслати?",
    "docs": [
     [
      "foerderleitfaden",
      "Посібник із фінансування (німецькою мовою)"
     ],
     [
      "schwammstadt",
      "Місто-губка"
     ],
     [
      "baum",
      "Дерево і тінь"
     ],
     [
      "klima",
      "Клімат"
     ],
     [
      "wasser",
      "Вода"
     ],
     [
      "solar",
      "Сонце і зарядка"
     ],
     [
      "licht",
      "Світло"
     ],
     [
      "bank",
      "Лавка"
     ],
     [
      "service",
      "Сервіс та інформація"
     ],
     [
      "mobil",
      "Мобільний"
     ]
    ],
    "hint1": "Ваші дані ми використовуємо лише для відповіді на Ваш запит. Детальніше – у ",
    "hintLink": "Політиці конфіденційності",
    "hint2": ".",
    "submit": "Надіслати запит і отримати документи",
    "sending": "Надсилання …",
    "ok": "Дякуємо! Ми особисто зв'яжемося з вами протягом двох робочих днів.",
    "err": "На жаль, не вдалося надіслати. Напишіть нам безпосередньо на info@berlin-cube.de."
   }
  },
  "footer": {
   "claim": "Designed in Berlin. Built for Europe.",
   "impressum": "Вихідні дані",
   "datenschutz": "Конфіденційність"
  },
  "seo": {
   "title": "BERLIN-CUBE | Зони безпеки стають просторами для життя.",
   "description": "Тінь, дерева, дощова вода та місця для сидіння для спекотних центрів міст. А ще захист від проїзду транспорту, випробуваний у краш-тесті DEKRA. Одна модульна система, багато рішень."
  },
  "kantStatus": "З червня по вересень 2026 року. Встановлено без фундаменту, демонтовано без жодних слідів."
 },
 "it": {
  "nav": [
   [
    "#loesungen",
    "Soluzioni"
   ],
   [
    "#kombinieren",
    "Dimensioni"
   ],
   [
    "#nachweis",
    "Prove"
   ],
   [
    "#anwendungen",
    "Applicazioni"
   ],
   [
    "#foerderung",
    "Finanziamenti"
   ],
   [
    "#kontakt",
    "Contatti"
   ]
  ],
  "cta": "Richieda un colloquio",
  "badge": {
   "foto": "FOTO",
   "video": "VIDEO",
   "vorf": "DIMOSTRAZIONE",
   "heute": "OGGI · FOTO",
   "morgen": "DOMANI · VISUALIZZAZIONE",
   "vis": "VISUALIZZAZIONE",
   "bg": "SFONDO: VISUALIZZAZIONE"
  },
  "hero": {
   "kicker": "INFRASTRUTTURA URBANA ADATTATA AL CLIMA",
   "h1a": "Gli spazi di sicurezza",
   "h1b": "diventano ",
   "h1c": "luoghi di vita.",
   "p": "Ombra, alberi, acqua piovana e sedute per i centri urbani surriscaldati. E in più una protezione antisfondamento, testata in un crash test DEKRA. Un solo sistema modulare, molte soluzioni.",
   "a": "Scopra le soluzioni"
  },
  "facts": [
   [
    "1,44 m²",
    "di verde urbano per modulo"
   ],
   [
    "circa 190 litri",
    "di accumulo d’acqua piovana per modulo città spugna, da calcolo"
   ],
   [
    "IWA 14-1",
    "Crash test DEKRA · 7.114 kg · 63,9 km/h"
   ],
   [
    "EP 3 486 374",
    "Brevetto europeo"
   ]
  ],
  "fuer": [
   "PER",
   [
    "Città e comuni",
    "Urbanistica e uffici del verde pubblico",
    "Gestione dei centri urbani e organizzatori di eventi",
    "Quartieri e investitori"
   ]
  ],
  "manifest": {
   "h2": "Ci siamo abituati al cemento.",
   "p1": "Alle barriere bianche e rosse davanti alle chiese. Alle transenne davanti a ogni mercatino di Natale. Alle piazze che sembrano cantieri.",
   "p2": "Eppure proprio lì potrebbe esserci un albero. Una panchina. Ombra in una giornata calda.",
   "claim1": "La sicurezza non deve vedersi.",
   "claim2": "Deve essere vissuta.",
   "alt": "Ingresso di un mercatino di Natale berlinese con barriere bianche e rosse e piastre a terra gialle e nere",
   "cap": "Mercatino di Natale sulla Breitscheidplatz, Berlino."
  },
  "hm": {
   "kicker": "BREITSCHEIDPLATZ, BERLINO",
   "h2a": "Stesso luogo. ",
   "h2b": "Altra atmosfera.",
   "heute": "Oggi",
   "morgen": "Domani",
   "altH": "La Breitscheidplatz oggi: blocchi di cemento e tende davanti alla Chiesa della Memoria",
   "altM": "La Breitscheidplatz domani: Berlin-Cube con alberi, panchine e luci davanti alla Chiesa della Memoria",
   "capH": "Oggi: blocchi di cemento, transenne e nastro segnaletico davanti alla Chiesa della Memoria. Sicuro, ma nessuno ha voglia di fermarsi.",
   "capM": "Domani: la stessa sicurezza, con in più alberi, panchine, luce e ombra. Una piazza in cui ci si incontra."
  },
  "prinzip": {
   "kicker": "IL PRINCIPIO",
   "h2a": "Un modulo.",
   "h2b": "Cinque funzioni.",
   "p": "Al posto di blocchi di cemento e dissuasori, un modulo in acciaio zincato a caldo che protegge e al tempo stesso rinfresca, porta verde e invita a sostare. Posato senza fondazioni, rimovibile senza lasciare tracce.",
   "alt": "Berlin-Cube piantumato con lavanda nella Kantstraße, Berlino",
   "items": [
    [
     "Clima e CO₂",
     "Alberi e piante assorbono CO₂, fanno ombra e rinfrescano grazie all’evapotraspirazione. La pioggia resta nel substrato anziché finire in fognatura."
    ],
    [
     "Verde urbano",
     "Verde anche su piazze impermeabilizzate e sopra i sottoservizi, senza fossa d’impianto."
    ],
    [
     "Sosta",
     "Sedersi, respirare, trattenersi. Con luce la sera."
    ],
    [
     "Smart City",
     "Solare, ricarica, informazione: predisposto come piattaforma."
    ],
    [
     "Sicurezza",
     "Protezione antisfondamento, testata in un crash test DEKRA secondo IWA 14-1:2013."
    ]
   ]
  },
  "loesungen": {
   "kicker": "LE SOLUZIONI",
   "h2a": "Un sistema di base.",
   "h2b": "Nove risposte per la città.",
   "p": "Tutte le varianti si basano sul Cube testato e sul suo collegamento a fune. Gli allestimenti sono concept in fase di sviluppo. Per ciascuno è disponibile un PDF dettagliato con disegni e spiegazioni. Saremo lieti di inviarglielo.",
   "feat": {
    "tag": "CITTÀ SPUGNA",
    "h3": "Pioggia, spazio per le radici e sosta in un solo modulo.",
    "alt": "Sezione di un Cube città spugna con serbatoio d’acqua e radici che crescono nel terreno attraverso il fondo aperto",
    "li": [
     "Circa 190 litri di accumulo per modulo da calcolo, più l’afflusso dalla pavimentazione",
     "Fondo aperto: le radici crescono nel terreno",
     "Alberi su piazze impermeabilizzate",
     "Elettricità, dati e acqua tramite una canaletta tecnica prevista"
    ],
    "cta": "Richieda il concept Città spugna"
   },
   "more": "Richieda il concept →",
   "cards": [
    [
     "baum",
     "Albero & ombra",
     "Alberi su pavimentazioni e sopra i sottoservizi, in tre dimensioni.",
     "Grande Cube con albero e panchina in una piazza"
    ],
    [
     "klima",
     "Clima",
     "Raffrescamento per le isole di calore: ombra, evaporazione, nebulizzazione.",
     "Cube clima con vela ombreggiante sopra le sedute"
    ],
    [
     "wasser",
     "Acqua",
     "Fontanella e nebulizzazione, integrate nel Cube.",
     "Nebulizzazione tra Cube piantumati in una giornata di caldo"
    ],
    [
     "solar",
     "Solare & ricarica",
     "Energia propria per illuminazione ed e-bike, allacciamento alla rete per le auto.",
     "Cube con tetto solare sopra una panchina"
    ],
    [
     "licht",
     "Luce",
     "Piazze luminose e sicure la sera, con sensori e rispettose degli insetti.",
     "Cube illuminati la sera davanti alla Chiesa della Memoria"
    ],
    [
     "bank",
     "Panchina",
     "Sedersi e proteggere insieme: una panchina su tre travi in acciaio HEB.",
     "Panchina tra due Cube piantumati la sera"
    ],
    [
     "service",
     "Servizi & info",
     "Rifiuti, informazione urbana e pubblicità, integrati anziché aggiunti.",
     "Piazza con Cube per rifiuti, informazione e pubblicità"
    ],
    [
     "mobil",
     "Mobile",
     "Una protezione antisfondamento che si apre per vigili del fuoco, soccorsi e consegne.",
     "Cube mobili su ruote come protezione antisfondamento apribile"
    ]
   ],
   "note": "Tutte le immagini di questa sezione sono visualizzazioni. Stato dei concept: ottobre 2026."
  },
  "groessen": {
   "kicker": "DIMENSIONI E COMBINAZIONI",
   "h2a": "Davanti la protezione.",
   "h2b": "Dietro l’ombra.",
   "p1": "Una fila testata di Cube da 1,20 m mette in sicurezza l’accesso. Dietro, Cube più grandi con alberi per ombra, raffrescamento e assorbimento di CO₂. Così una barriera diventa una vera piazza.",
   "p2": "Tutte le dimensioni con la stessa costruzione e lo stesso design, liberamente combinabili con panchina, luce, acqua e solare.",
   "sizes": [
    [
     "1,20 m",
     "Testato",
     72,
     72,
     "#141712"
    ],
    [
     "1,50 m",
     "In sviluppo",
     90,
     90,
     "#3a4234"
    ],
    [
     "2,00 m",
     "In sviluppo",
     120,
     120,
     "#5b6353"
    ],
    [
     "3,00 × 2,00 m",
     "In progettazione",
     180,
     120,
     null
    ],
    [
     "3,00 × 3,00 m",
     "In progettazione",
     180,
     180,
     null
    ]
   ],
   "note": "Superfici di base rappresentate in scala."
  },
  "vergleich": {
   "kicker": "IL CONFRONTO",
   "h2a": "Cosa fa una barriera. ",
   "h2b": "E cosa fa un Cube.",
   "head": [
    "Blocco di cemento",
    "Dissuasore",
    "Berlin-Cube"
   ],
   "rows": [
    [
     "Protezione antisfondamento",
     "a seconda del prodotto",
     "a seconda del prodotto",
     "testato secondo IWA 14-1"
    ],
    [
     "Verde urbano",
     "—",
     "—",
     "1,44 m² per modulo"
    ],
    [
     "Acqua piovana",
     "—",
     "—",
     "resta nel substrato"
    ],
    [
     "Ombra e raffrescamento",
     "—",
     "—",
     "con albero o vela ombreggiante"
    ],
    [
     "Sedute",
     "—",
     "—",
     "sì"
    ],
    [
     "Luce la sera",
     "—",
     "in parte",
     "bordi LED di serie"
    ],
    [
     "Senza fondazioni",
     "sì",
     "per lo più no",
     "sì"
    ],
    [
     "Effetto sul paesaggio urbano",
     "zona interdetta",
     "barriera",
     "luogo in cui sostare"
    ]
   ]
  },
  "nachweis": {
   "kicker": "LA PROVA",
   "h2a": "L’abbiamo",
   "h2b": "speronato di proposito.",
   "dl": [
    [
     "Norma",
     "IWA 14-1:2013"
    ],
    [
     "Veicolo",
     "7.114 kg"
    ],
    [
     "Velocità",
     "63,9 km/h"
    ],
    [
     "Zona sicura",
     "da 7,95 m dietro il modulo"
    ],
    [
     "Rapporto di prova",
     "DEKRA n. 201844624"
    ]
   ],
   "note": "Sono testati il Cube e il collegamento a fune. Prossima generazione: crash test secondo ISO 22343-1 in programma."
  },
  "realisiert": {
   "kicker": "REALIZZATO",
   "h2a": "Non domani. ",
   "h2b": "Oggi.",
   "all": "Vedi tutti i progetti →",
   "items": [
    [
     "video",
     "Video: Berlin-Cube illuminati nella Kantstraße al tramonto",
     "Progetto pilota Kantstraße, Berlino",
     "Da giugno a settembre 2026. Posato senza fondazioni, rimosso senza lasciare tracce."
    ],
    [
     "foto",
     "Panchina con seduta in legno su un Berlin-Cube piantumato nella Kantstraße, di giorno",
     "Sedersi anziché sbarrare",
     "Panchine, verde e protezione antisfondamento in un’unica fila."
    ],
    [
     "vorf",
     "Dimostrazione di tre Berlin-Cube con rampa presso un outlet center a Wustermark",
     "Wustermark, Brandeburgo",
     "Dimostrazione presso un outlet center: rampa, punto di ricarica, albero."
    ]
   ]
  },
  "ablauf": {
   "kicker": "COME SI SVOLGE UN PROGETTO",
   "h2a": "Un unico interlocutore. ",
   "h2b": "In quattro passi.",
   "steps": [
    [
     "Richiesta",
     "Ci indica la Sua piazza e che cosa deve offrire."
    ],
    [
     "Sito e finanziamento",
     "Esaminiamo il luogo e Le indichiamo i finanziamenti adatti."
    ],
    [
     "Progettazione",
     "Disposizione, varianti, piantumazione e illuminazione per la Sua piazza."
    ],
    [
     "Fornitura e posa",
     "Tempi di consegna di circa 2–3 mesi a seconda delle quantità. Posa senza fondazioni."
    ]
   ]
  },
  "anwendungen": {
   "kicker": "APPLICAZIONI",
   "h2a": "Da dove vuole ",
   "h2b": "cominciare?",
   "links": [
    [
     "/en/climate-adaptation-street-space",
     "Adattamento climatico e protezione dal caldo"
    ],
    [
     "/en/vehicle-security-barriers-pedestrian-zones",
     "Zone pedonali e centri storici"
    ],
    [
     "/en/vehicle-security-barriers-christmas-markets",
     "Mercatini di Natale"
    ],
    [
     "/en/vehicle-barriers-events",
     "Eventi e feste cittadine"
    ],
    [
     "/en/vehicle-protection-cultural-venues",
     "Luoghi della cultura e piazze"
    ],
    [
     "/en/vehicle-protection-government-buildings",
     "Amministrazioni ed edifici pubblici"
    ]
   ]
  },
  "foerderung": {
   "kicker": "FINANZIAMENTI",
   "h2a": "Un unico interlocutore per ",
   "h2b": "soluzione e finanziamento.",
   "p": "Adattamento climatico, città spugna, verde urbano e qualità dello spazio pubblico: per questi temi esistono finanziamenti pubblici, nazionali ed europei. La aiutiamo a individuare la strada adatta alla Sua piazza.",
   "cta": "Richieda una prima valutazione"
  },
  "presse": {
   "quote": "«È meglio che barricare tutto.»",
   "by": "Kirstin Bauch, sindaca del distretto di Charlottenburg-Wilmersdorf (Berlino), sulla Berliner Morgenpost (tradotto dal tedesco)",
   "kicker": "NE HANNO PARLATO",
   "list": "rbb24 Abendschau · radio3 · Tagesspiegel · Berliner Morgenpost · Entwicklungsstadt Berlin"
  },
  "erfinder": {
   "kicker": "INVENTORE E PRODUTTORE",
   "h2a": "Inventato a Berlino.",
   "h2b": "Costruito nel Brandeburgo.",
   "p1": "Martin Fichtelmann ha sviluppato il Cube e lo ha tutelato con il brevetto europeo EP 3 486 374. Da paesaggista sa di che cosa hanno bisogno le piante in una piazza urbana, e costruisce il Cube a Wustermark, vicino a Berlino.",
   "p2": "Un unico interlocutore, dalla prima idea alla manutenzione.",
   "alt": "Martin Fichtelmann, Erfinder des Berlin-Cube, am Breitscheidplatz in Berlin"
  },
  "kontakt": {
   "kicker": "CONTATTI",
   "h2a": "Immagini la Sua piazza",
   "h2b": "tra un anno.",
   "p": "Le mostriamo come potrebbe essere. E come finanziarla.",
   "p2": "Ci scriva in breve dove e che cosa. Riceverà via e-mail i documenti richiesti e da parte nostra una prima valutazione con le possibili vie di finanziamento.",
   "addr": "Berliner Allee 37–39, 14641 Wustermark, Germania",
   "f": {
    "name": "Nome e cognome",
    "org": "Città, comune o ente",
    "email": "E-mail",
    "ort": "Tipo di luogo",
    "orte": [
     "Piazza o zona pedonale",
     "Mercatino di Natale o evento",
     "Isola di calore o adattamento climatico",
     "Luogo della cultura o amministrazione",
     "Altro"
    ],
    "laenge": "Lunghezza indicativa in metri",
    "msg": "Messaggio",
    "legend": "Quali documenti possiamo inviarLe?",
    "docs": [
     [
      "foerderleitfaden",
      "Guida ai finanziamenti (in tedesco)"
     ],
     [
      "schwammstadt",
      "Città spugna"
     ],
     [
      "baum",
      "Albero & ombra"
     ],
     [
      "klima",
      "Clima"
     ],
     [
      "wasser",
      "Acqua"
     ],
     [
      "solar",
      "Solare & ricarica"
     ],
     [
      "licht",
      "Luce"
     ],
     [
      "bank",
      "Panchina"
     ],
     [
      "service",
      "Servizi & info"
     ],
     [
      "mobil",
      "Mobile"
     ]
    ],
    "hint1": "Utilizziamo i Suoi dati solo per rispondere alla Sua richiesta. Per maggiori informazioni consulti la nostra ",
    "hintLink": "informativa sulla privacy",
    "hint2": ".",
    "submit": "Invii la richiesta e riceva i documenti",
    "sending": "Invio in corso …",
    "ok": "Grazie! La contatteremo personalmente entro due giorni lavorativi.",
    "err": "Purtroppo non ha funzionato. Ci scriva direttamente a info@berlin-cube.de."
   }
  },
  "footer": {
   "claim": "Designed in Berlin. Built for Europe.",
   "impressum": "Note legali",
   "datenschutz": "Privacy"
  },
  "seo": {
   "title": "BERLIN-CUBE | Gli spazi di sicurezza diventano luoghi di vita.",
   "description": "Ombra, alberi, acqua piovana e sedute per i centri urbani surriscaldati. E in più una protezione antisfondamento, testata in un crash test DEKRA. Un solo sistema modulare, molte soluzioni."
  },
  "kantStatus": "Da giugno a settembre 2026. Posato senza fondazioni, rimosso senza lasciare tracce."
 },
 "nl": {
  "nav": [
   [
    "#loesungen",
    "Oplossingen"
   ],
   [
    "#kombinieren",
    "Formaten"
   ],
   [
    "#nachweis",
    "Bewijs"
   ],
   [
    "#anwendungen",
    "Toepassingen"
   ],
   [
    "#foerderung",
    "Financiering"
   ],
   [
    "#kontakt",
    "Contact"
   ]
  ],
  "cta": "Gesprek aanvragen",
  "badge": {
   "foto": "FOTO",
   "video": "VIDEO",
   "vorf": "DEMONSTRATIE",
   "heute": "VANDAAG · FOTO",
   "morgen": "MORGEN · VISUALISATIE",
   "vis": "VISUALISATIE",
   "bg": "ACHTERGROND: VISUALISATIE"
  },
  "hero": {
   "kicker": "KLIMAATBESTENDIGE STADSINFRASTRUCTUUR",
   "h1a": "Veiligheidszones",
   "h1b": "worden ",
   "h1c": "leefruimtes.",
   "p": "Schaduw, bomen, regenwater en zitplaatsen voor hete binnensteden. En daarbij voertuigwering, getest in een DEKRA-crashtest. Eén modulair systeem, veel oplossingen.",
   "a": "Oplossingen bekijken"
  },
  "facts": [
   [
    "1,44 m²",
    "Stadsgroen per module"
   ],
   [
    "circa 190 liter",
    "Regenwaterbuffer per sponsstadmodule, berekend"
   ],
   [
    "IWA 14-1",
    "DEKRA-crashtest · 7.114 kg · 63,9 km/u"
   ],
   [
    "EP 3 486 374",
    "Europees octrooi"
   ]
  ],
  "fuer": [
   "VOOR",
   [
    "Steden en gemeenten",
    "Stedenbouw en groenbeheer",
    "Citymanagement en organisatoren",
    "Wijken en investeerders"
   ]
  ],
  "manifest": {
   "h2": "We zijn gewend geraakt aan beton.",
   "p1": "Aan rood-witte barrières voor kerken. Aan hekken voor elke kerstmarkt. Aan pleinen die eruitzien als bouwplaatsen.",
   "p2": "Terwijl daar juist een boom zou kunnen staan. Een bank. Schaduw op een hete dag.",
   "claim1": "Veiligheid hoeft u niet te zien.",
   "claim2": "U moet haar beleven.",
   "alt": "Ingang van een Berlijnse kerstmarkt met rood-witte afzettingen en geel-zwarte bodemplaten",
   "cap": "Kerstmarkt op de Breitscheidplatz, Berlijn."
  },
  "hm": {
   "kicker": "BREITSCHEIDPLATZ, BERLIJN",
   "h2a": "Dezelfde plek. ",
   "h2b": "Een ander gevoel.",
   "heute": "Vandaag",
   "morgen": "Morgen",
   "altH": "Breitscheidplatz vandaag: betonblokken en tenten voor de Gedächtniskirche",
   "altM": "Breitscheidplatz morgen: Berlin-Cubes met bomen, banken en licht voor de Gedächtniskirche",
   "capH": "Vandaag: betonblokken, hekken en afzetlint voor de Gedächtniskirche. Veilig, maar niemand blijft er graag staan.",
   "capM": "Morgen: dezelfde veiligheid, met bomen, banken, licht en schaduw. Een plein waar mensen elkaar ontmoeten."
  },
  "prinzip": {
   "kicker": "HET PRINCIPE",
   "h2a": "Eén module.",
   "h2b": "Vijf taken.",
   "p": "In plaats van betonblokken en palen staat er een module van thermisch verzinkt staal die beschermt en tegelijk verkoelt, vergroent en uitnodigt om te blijven. Geplaatst zonder fundering, spoorloos weer te verwijderen.",
   "alt": "Beplante Berlin-Cube met lavendel in de Kantstraße, Berlijn",
   "items": [
    [
     "Klimaat en CO₂",
     "Bomen en planten binden CO₂, geven schaduw en verkoelen door verdamping. Regen blijft in het substraat in plaats van in het riool."
    ],
    [
     "Stadsgroen",
     "Groen ook op verharde pleinen en boven leidingen, zonder boomkuil."
    ],
    [
     "Verblijf",
     "Zitten, op adem komen, blijven. Met licht in de avond."
    ],
    [
     "Smart City",
     "Zonne-energie, laden, informatie: voorbereid als platform."
    ],
    [
     "Veiligheid",
     "Voertuigwering, getest in een DEKRA-crashtest volgens IWA 14-1:2013."
    ]
   ]
  },
  "loesungen": {
   "kicker": "DE OPLOSSINGEN",
   "h2a": "Eén basissysteem.",
   "h2b": "Negen antwoorden voor de stad.",
   "p": "Alle varianten bouwen voort op de geteste Cube en zijn staalkabelverbinding. De uitvoeringen zijn concepten in ontwikkeling. Voor elk ervan is er een uitgebreide concept-pdf met tekeningen en toelichting. Wij sturen die u graag toe.",
   "feat": {
    "tag": "SPONSSTAD",
    "h3": "Regen, wortelruimte en verblijf in één module.",
    "alt": "Doorsnede van een sponsstad-cube met waterbuffer en wortels die via de open onderzijde de bodem in groeien",
    "li": [
     "Berekend circa 190 liter buffer per module, plus toevoer vanaf de bestrating",
     "Open onderzijde: wortels groeien de bodem in",
     "Bomen op verharde pleinen",
     "Stroom, data en water via een geplande functionele goot"
    ],
    "cta": "Concept sponsstad aanvragen"
   },
   "more": "Concept aanvragen →",
   "cards": [
    [
     "baum",
     "Boom & schaduw",
     "Bomen op bestrating en boven leidingen, in drie formaten.",
     "Grote boom-cube met bank op een stadsplein"
    ],
    [
     "klima",
     "Klimaat",
     "Verkoeling voor hittehotspots: schaduw, verdamping, vernevelaars.",
     "Klimaat-cubes met schaduwzeil boven zitplaatsen"
    ],
    [
     "wasser",
     "Water",
     "Drinkwaterfontein en vernevelaars, ingebouwd in de Cube.",
     "Vernevelaars tussen beplante cubes op een hete dag"
    ],
    [
     "solar",
     "Zon & laden",
     "Eigen stroom voor licht en e-bikes, netaansluiting voor de auto.",
     "Cube met zonnedak boven een bank"
    ],
    [
     "licht",
     "Licht",
     "Lichte, veilige pleinen in de avond, met sensorsturing en insectvriendelijk.",
     "Verlichte cubes in de avond voor de Gedächtniskirche"
    ],
    [
     "bank",
     "Bank",
     "Zitten en afschermen in één: een bank op drie HEB-stalen liggers.",
     "Bank tussen twee plantencubes in de avond"
    ],
    [
     "service",
     "Service & info",
     "Afval, stadsinformatie en reclame, ingebouwd in plaats van erbij gezet.",
     "Plein met cubes voor afval, informatie en reclame"
    ],
    [
     "mobil",
     "Mobiel",
     "Voertuigwering die open kan voor brandweer, ambulance en bevoorrading.",
     "Verrijdbare cubes op wielen als te openen voertuigwering"
    ]
   ],
   "note": "Alle beelden in dit gedeelte zijn visualisaties. Conceptstand oktober 2026."
  },
  "groessen": {
   "kicker": "FORMATEN EN COMBINATIES",
   "h2a": "Vooraan bescherming.",
   "h2b": "Daarachter schaduw.",
   "p1": "Een geteste beschermingsrij van cubes van 1,20 m beveiligt de toegang. Daarachter staan grotere boom-cubes voor schaduw, verkoeling en CO₂-binding. Zo wordt een afzetting een volwaardig plein.",
   "p2": "Alle formaten in dezelfde bouwwijze en uitstraling, vrij te combineren met bank, licht, water en zonne-energie.",
   "sizes": [
    [
     "1,20 m",
     "Getest",
     72,
     72,
     "#141712"
    ],
    [
     "1,50 m",
     "In ontwikkeling",
     90,
     90,
     "#3a4234"
    ],
    [
     "2,00 m",
     "In ontwikkeling",
     120,
     120,
     "#5b6353"
    ],
    [
     "3,00 × 2,00 m",
     "In planning",
     180,
     120,
     null
    ],
    [
     "3,00 × 3,00 m",
     "In planning",
     180,
     180,
     null
    ]
   ],
   "note": "Grondvlakken op schaal weergegeven."
  },
  "vergleich": {
   "kicker": "DE VERGELIJKING",
   "h2a": "Wat een barrière kan. ",
   "h2b": "En wat een Cube kan.",
   "head": [
    "Betonblok",
    "Paal",
    "Berlin-Cube"
   ],
   "rows": [
    [
     "Voertuigwering",
     "afhankelijk van product",
     "afhankelijk van product",
     "getest volgens IWA 14-1"
    ],
    [
     "Stadsgroen",
     "—",
     "—",
     "1,44 m² per module"
    ],
    [
     "Regenwater",
     "—",
     "—",
     "blijft in het substraat"
    ],
    [
     "Schaduw en verkoeling",
     "—",
     "—",
     "met boom of zeil"
    ],
    [
     "Zitplaatsen",
     "—",
     "—",
     "ja"
    ],
    [
     "Licht in de avond",
     "—",
     "deels",
     "LED-randen standaard"
    ],
    [
     "Zonder fundering",
     "ja",
     "meestal niet",
     "ja"
    ],
    [
     "Effect op het stadsbeeld",
     "verboden zone",
     "barrière",
     "plek om te verblijven"
    ]
   ]
  },
  "nachweis": {
   "kicker": "HET BEWIJS",
   "h2a": "We hebben hem",
   "h2b": "met opzet geramd.",
   "dl": [
    [
     "Norm",
     "IWA 14-1:2013"
    ],
    [
     "Voertuig",
     "7.114 kg"
    ],
    [
     "Snelheid",
     "63,9 km/h"
    ],
    [
     "Veilige zone",
     "vanaf 7,95 m achter de module"
    ],
    [
     "Testrapport",
     "DEKRA nr. 201844624"
    ]
   ],
   "note": "Getest zijn de Cube en de staalkabelverbinding. Volgende generatie: crashtest volgens ISO 22343-1 in planning."
  },
  "realisiert": {
   "kicker": "GEREALISEERD",
   "h2a": "Niet morgen. ",
   "h2b": "Vandaag.",
   "all": "Alle projecten bekijken →",
   "items": [
    [
     "video",
     "Video: verlichte Berlin-Cubes in de Kantstraße bij zonsondergang",
     "Pilot Kantstraße, Berlijn",
     "Juni tot september 2026. Geplaatst zonder fundering, spoorloos verwijderd."
    ],
    [
     "foto",
     "Zitbank met houten zitting aan een beplante Berlin-Cube in de Kantstraße overdag",
     "Zitten in plaats van afzetten",
     "Banken, groen en voertuigwering in één rij."
    ],
    [
     "vorf",
     "Demonstratie van drie Berlin-Cubes met helling bij een outletcenter in Wustermark",
     "Wustermark, Brandenburg",
     "Demonstratie bij een outletcenter: helling, laadpunt, boom."
    ]
   ]
  },
  "ablauf": {
   "kicker": "ZO VERLOOPT EEN PROJECT",
   "h2a": "Alles uit één hand. ",
   "h2b": "In vier stappen.",
   "steps": [
    [
     "Aanvraag",
     "U vertelt ons over uw plein en wat het moet kunnen."
    ],
    [
     "Locatie en financiering",
     "Wij beoordelen de locatie en laten zien welke financiering past."
    ],
    [
     "Ontwerp",
     "Opstelling, varianten, beplanting en licht voor uw plein."
    ],
    [
     "Levering en plaatsing",
     "Levertijd circa 2 tot 3 maanden, afhankelijk van het aantal. Plaatsing zonder fundering."
    ]
   ]
  },
  "anwendungen": {
   "kicker": "TOEPASSINGEN",
   "h2a": "Waar wilt u ",
   "h2b": "beginnen?",
   "links": [
    [
     "/en/climate-adaptation-street-space",
     "Klimaatadaptatie en hittebestrijding"
    ],
    [
     "/en/vehicle-security-barriers-pedestrian-zones",
     "Voetgangersgebieden en binnensteden"
    ],
    [
     "/en/vehicle-security-barriers-christmas-markets",
     "Kerstmarkten"
    ],
    [
     "/en/vehicle-barriers-events",
     "Evenementen en stadsfeesten"
    ],
    [
     "/en/vehicle-protection-cultural-venues",
     "Cultuurlocaties en pleinen"
    ],
    [
     "/en/vehicle-protection-government-buildings",
     "Overheid en openbare gebouwen"
    ]
   ]
  },
  "foerderung": {
   "kicker": "FINANCIERING",
   "h2a": "Eén aanspreekpunt voor ",
   "h2b": "oplossing en financiering.",
   "p": "Klimaatadaptatie, sponsstad, stadsgroen en verblijfskwaliteit: voor deze thema's bestaan nationale en Europese subsidiemogelijkheden. Wij helpen u de route te vinden die bij uw plein past.",
   "cta": "Vraag een eerste beoordeling aan"
  },
  "presse": {
   "quote": "„Dit is beter dan alles te barricaderen.”",
   "by": "Kirstin Bauch, burgemeester van het stadsdeel Charlottenburg-Wilmersdorf (Berlijn), in de Berliner Morgenpost (vertaald uit het Duits)",
   "kicker": "IN DE PERS",
   "list": "rbb24 Abendschau · radio3 · Tagesspiegel · Berliner Morgenpost · Entwicklungsstadt Berlin"
  },
  "erfinder": {
   "kicker": "UITVINDER EN FABRIKANT",
   "h2a": "Uitgevonden in Berlijn.",
   "h2b": "Gebouwd in Brandenburg.",
   "p1": "Martin Fichtelmann heeft de Cube ontwikkeld en beschermd met het Europese octrooi EP 3 486 374. Als hovenier weet hij wat planten op een stadsplein nodig hebben, en hij bouwt de Cube in Wustermark bij Berlijn.",
   "p2": "Eén aanspreekpunt, van het eerste idee tot het onderhoud.",
   "alt": "Martin Fichtelmann, Erfinder des Berlin-Cube, am Breitscheidplatz in Berlin"
  },
  "kontakt": {
   "kicker": "CONTACT",
   "h2a": "Stel u uw plein voor",
   "h2b": "over een jaar.",
   "p": "Wij laten u zien hoe het eruit kan zien. En hoe het wordt gefinancierd.",
   "p2": "Laat ons kort weten waar en wat. U ontvangt de gewenste documenten per e-mail en van ons een eerste beoordeling met de passende financieringsmogelijkheden.",
   "addr": "Berliner Allee 37–39, 14641 Wustermark, Duitsland",
   "f": {
    "name": "Naam",
    "org": "Stad, gemeente of organisatie",
    "email": "E-mail",
    "ort": "Soort locatie",
    "orte": [
     "Plein of voetgangersgebied",
     "Kerstmarkt of evenement",
     "Hittehotspot of klimaatadaptatie",
     "Cultuurlocatie of overheid",
     "Iets anders"
    ],
    "laenge": "Geschatte lengte in meters",
    "msg": "Bericht",
    "legend": "Welke documenten mogen wij u sturen?",
    "docs": [
     [
      "foerderleitfaden",
      "Subsidiegids (in het Duits)"
     ],
     [
      "schwammstadt",
      "Sponsstad"
     ],
     [
      "baum",
      "Boom & schaduw"
     ],
     [
      "klima",
      "Klimaat"
     ],
     [
      "wasser",
      "Water"
     ],
     [
      "solar",
      "Zon & laden"
     ],
     [
      "licht",
      "Licht"
     ],
     [
      "bank",
      "Bank"
     ],
     [
      "service",
      "Service & info"
     ],
     [
      "mobil",
      "Mobiel"
     ]
    ],
    "hint1": "Wij gebruiken uw gegevens alleen om uw aanvraag te beantwoorden. Meer hierover in de ",
    "hintLink": "privacyverklaring",
    "hint2": ".",
    "submit": "Aanvraag versturen en documenten ontvangen",
    "sending": "Wordt verzonden …",
    "ok": "Bedankt! Wij nemen binnen twee werkdagen persoonlijk contact met u op.",
    "err": "Dat is helaas niet gelukt. Mail ons direct via info@berlin-cube.de."
   }
  },
  "footer": {
   "claim": "Designed in Berlin. Built for Europe.",
   "impressum": "Colofon",
   "datenschutz": "Privacy"
  },
  "seo": {
   "title": "BERLIN-CUBE | Veiligheidszones worden leefruimtes.",
   "description": "Schaduw, bomen, regenwater en zitplaatsen voor hete binnensteden. En daarbij voertuigwering, getest in een DEKRA-crashtest. Eén modulair systeem, veel oplossingen."
  },
  "kantStatus": "Juni tot september 2026. Geplaatst zonder fundering, spoorloos verwijderd."
 },
 "cs": {
  "nav": [
   [
    "#loesungen",
    "Řešení"
   ],
   [
    "#kombinieren",
    "Velikosti"
   ],
   [
    "#nachweis",
    "Důkaz"
   ],
   [
    "#anwendungen",
    "Využití"
   ],
   [
    "#foerderung",
    "Financování"
   ],
   [
    "#kontakt",
    "Kontakt"
   ]
  ],
  "cta": "Domluvit schůzku",
  "badge": {
   "foto": "FOTO",
   "video": "VIDEO",
   "vorf": "UKÁZKA",
   "heute": "DNES · FOTO",
   "morgen": "ZÍTRA · VIZUALIZACE",
   "vis": "VIZUALIZACE",
   "bg": "POZADÍ: VIZUALIZACE"
  },
  "hero": {
   "kicker": "MĚSTSKÁ INFRASTRUKTURA PŘIZPŮSOBENÁ KLIMATU",
   "h1a": "Z bezpečnostních zón",
   "h1b": "se stávají ",
   "h1c": "místa k životu.",
   "p": "Stín, stromy, dešťová voda a místa k sezení pro rozpálená centra měst. A k tomu ochrana proti vjezdu vozidel, testovaná při nárazové zkoušce DEKRA. Jeden modulární systém, mnoho řešení.",
   "a": "Zobrazit řešení"
  },
  "facts": [
   [
    "1,44 m²",
    "zeleně na modul"
   ],
   [
    "přibližně 190 litrů",
    "zadržené dešťové vody na modul „houbové město“, dle výpočtu"
   ],
   [
    "IWA 14-1",
    "Nárazová zkouška DEKRA · 7 114 kg · 63,9 km/h"
   ],
   [
    "EP 3 486 374",
    "Evropský patent"
   ]
  ],
  "fuer": [
   "PRO",
   [
    "Města a obce",
    "Územní plánování a odbory zeleně",
    "City management a pořadatele akcí",
    "Čtvrti a investory"
   ]
  ],
  "manifest": {
   "h2": "Zvykli jsme si na beton.",
   "p1": "Na červenobílé zábrany před kostely. Na zábradlí před každým vánočním trhem. Na náměstí, která vypadají jako staveniště.",
   "p2": "Přitom právě tam by mohl stát strom. Lavička. Stín v horkém dni.",
   "claim1": "Bezpečnost nemusí být vidět.",
   "claim2": "Má se prožívat.",
   "alt": "Vstup na berlínský vánoční trh s červenobílými zábranami a žlutočernými podlahovými deskami",
   "cap": "Vánoční trh na Breitscheidplatz v Berlíně."
  },
  "hm": {
   "kicker": "BREITSCHEIDPLATZ, BERLÍN",
   "h2a": "Stejné místo. ",
   "h2b": "Jiný pocit.",
   "heute": "Dnes",
   "morgen": "Zítra",
   "altH": "Breitscheidplatz dnes: betonové zábrany a stany před Pamětním kostelem",
   "altM": "Breitscheidplatz zítra: Berlin-Cuby se stromy, lavičkami a světlem před Pamětním kostelem",
   "capH": "Dnes: betonové zábrany, zábradlí a vytyčovací páska před Pamětním kostelem. Bezpečné, ale nikdo se tu rád nezastaví.",
   "capM": "Zítra: stejná bezpečnost, a k tomu stromy, lavičky, světlo a stín. Místo, kde se lidé potkávají."
  },
  "prinzip": {
   "kicker": "PRINCIP",
   "h2a": "Jeden modul.",
   "h2b": "Pět úkolů.",
   "p": "Místo betonových bloků a sloupků stojí modul z žárově zinkované oceli, který chrání a zároveň ochlazuje, přináší zeleň a zve k posezení. Instaluje se bez základů a lze jej beze stop odstranit.",
   "alt": "Osázený Berlin-Cube s levandulí v Kantstraße v Berlíně",
   "items": [
    [
     "Klima a CO₂",
     "Stromy a rostliny vážou CO₂, poskytují stín a ochlazují odpařováním. Déšť zůstává v substrátu, ne v kanalizaci."
    ],
    [
     "Městská zeleň",
     "Zeleň i na zpevněných plochách a nad inženýrskými sítěmi, bez stromové jámy."
    ],
    [
     "Pobyt",
     "Posedět, nadechnout se, zůstat. Večer se světlem."
    ],
    [
     "Smart City",
     "Solár, nabíjení, informace: připraveno jako platforma."
    ],
    [
     "Bezpečnost",
     "Ochrana proti vjezdu, testovaná při nárazové zkoušce DEKRA dle IWA 14-1:2013."
    ]
   ]
  },
  "loesungen": {
   "kicker": "ŘEŠENÍ",
   "h2a": "Jeden základní systém.",
   "h2b": "Devět odpovědí pro město.",
   "p": "Všechny varianty vycházejí z testovaného Cube a jeho lanového spojení. Jednotlivá vybavení jsou koncepty ve vývoji. Ke každému existuje podrobné koncepční PDF s výkresy a vysvětlivkami. Rádi Vám je zašleme.",
   "feat": {
    "tag": "HOUBOVÉ MĚSTO",
    "h3": "Déšť, kořenový prostor a pobyt v jednom modulu.",
    "alt": "Řez Cube pro houbové město se zásobníkem vody a kořeny, které prorůstají otevřenou spodní stranou do půdy",
    "li": [
     "Dle výpočtu přibližně 190 litrů zásobníku na modul, navíc přítok z dlažby",
     "Otevřená spodní strana: kořeny prorůstají do půdy",
     "Stromy na zpevněných plochách",
     "Elektřina, data a voda přes plánovaný funkční žlab"
    ],
    "cta": "Vyžádat koncept Houbové město"
   },
   "more": "Vyžádat koncept →",
   "cards": [
    [
     "baum",
     "Strom a stín",
     "Stromy na dlažbě a nad inženýrskými sítěmi, ve třech velikostech.",
     "Velký stromový Cube s lavičkou na městském náměstí"
    ],
    [
     "klima",
     "Klima",
     "Ochlazení horkých míst: stín, odpařování, vodní mlha.",
     "Klimatické Cuby se slunečními plachtami nad místy k sezení"
    ],
    [
     "wasser",
     "Voda",
     "Pítko a vodní mlha, zabudované v Cube.",
     "Vodní mlha mezi osázenými Cuby v horkém dni"
    ],
    [
     "solar",
     "Solár a nabíjení",
     "Vlastní elektřina pro světlo a elektrokola, síťová přípojka pro auta.",
     "Cube se solární střechou nad lavičkou"
    ],
    [
     "licht",
     "Světlo",
     "Světlá a bezpečná místa večer, řízená senzory a šetrná k hmyzu.",
     "Svítící Cuby večer před Pamětním kostelem"
    ],
    [
     "bank",
     "Lavička",
     "Sezení a zábrana v jednom: lavička na třech ocelových nosnících HEB.",
     "Lavička mezi dvěma osázenými Cuby večer"
    ],
    [
     "service",
     "Služby a info",
     "Odpad, městské informace a reklama – zabudované, ne přistavené.",
     "Náměstí s Cuby pro odpad, informace a reklamu"
    ],
    [
     "mobil",
     "Mobilní",
     "Ochrana proti vjezdu, kterou lze otevřít pro hasiče, záchranáře a zásobování.",
     "Pohyblivé Cuby na kolečkách jako otevíratelná ochrana proti vjezdu"
    ]
   ],
   "note": "Všechny obrázky v této části jsou vizualizace. Stav konceptu: říjen 2026."
  },
  "groessen": {
   "kicker": "VELIKOSTI A KOMBINACE",
   "h2a": "Vpředu ochrana.",
   "h2b": "Za ní stín.",
   "p1": "Testovaná ochranná řada z 1,20m Cubů zabezpečí vjezd. Za ní stojí větší stromové Cuby pro stín, ochlazení a vázání CO₂. Ze zábrany se tak stane celé náměstí.",
   "p2": "Všechny velikosti ve stejném provedení a vzhledu, volně kombinovatelné s lavičkou, světlem, vodou a solárem.",
   "sizes": [
    [
     "1,20 m",
     "Testováno",
     72,
     72,
     "#141712"
    ],
    [
     "1,50 m",
     "Ve vývoji",
     90,
     90,
     "#3a4234"
    ],
    [
     "2,00 m",
     "Ve vývoji",
     120,
     120,
     "#5b6353"
    ],
    [
     "3,00 × 2,00 m",
     "V plánu",
     180,
     120,
     null
    ],
    [
     "3,00 × 3,00 m",
     "V plánu",
     180,
     180,
     null
    ]
   ],
   "note": "Půdorysy zobrazeny v měřítku."
  },
  "vergleich": {
   "kicker": "SROVNÁNÍ",
   "h2a": "Co umí zábrana. ",
   "h2b": "A co umí Cube.",
   "head": [
    "Betonový blok",
    "Sloupek",
    "Berlin-Cube"
   ],
   "rows": [
    [
     "Ochrana proti vjezdu",
     "dle produktu",
     "dle produktu",
     "testováno dle IWA 14-1"
    ],
    [
     "Městská zeleň",
     "—",
     "—",
     "1,44 m² na modul"
    ],
    [
     "Dešťová voda",
     "—",
     "—",
     "zůstává v substrátu"
    ],
    [
     "Stín a ochlazení",
     "—",
     "—",
     "se stromem nebo plachtou"
    ],
    [
     "Místa k sezení",
     "—",
     "—",
     "ano"
    ],
    [
     "Světlo večer",
     "—",
     "částečně",
     "LED hrany v základu"
    ],
    [
     "Bez základů",
     "ano",
     "většinou ne",
     "ano"
    ],
    [
     "Působení v městském prostoru",
     "uzavřená zóna",
     "zábrana",
     "místo k pobytu"
    ]
   ]
  },
  "nachweis": {
   "kicker": "DŮKAZ",
   "h2a": "Narazili jsme do něj",
   "h2b": "schválně.",
   "dl": [
    [
     "Norma",
     "IWA 14-1:2013"
    ],
    [
     "Vozidlo",
     "7 114 kg"
    ],
    [
     "Rychlost",
     "63,9 km/h"
    ],
    [
     "Bezpečná zóna",
     "od 7,95 m za modulem"
    ],
    [
     "Zkušební protokol",
     "DEKRA č. 201844624"
    ]
   ],
   "note": "Testován je Cube a lanové spojení. Další generace: nárazová zkouška dle ISO 22343-1 v plánu."
  },
  "realisiert": {
   "kicker": "REALIZOVÁNO",
   "h2a": "Ne zítra. ",
   "h2b": "Dnes.",
   "all": "Zobrazit všechny projekty →",
   "items": [
    [
     "video",
     "Video: osvětlené Berlin-Cuby v Kantstraße při západu slunce",
     "Pilotní projekt Kantstraße, Berlín",
     "Červen až září 2026. Instalováno bez základů, odstraněno beze stop."
    ],
    [
     "foto",
     "Lavička s dřevěným sedákem u osázeného Berlin-Cube v Kantstraße za dne",
     "Sezení místo zábran",
     "Lavičky, zeleň a ochrana proti vjezdu v jedné řadě."
    ],
    [
     "vorf",
     "Ukázka tří Berlin-Cubů s rampou u outletového centra ve Wustermarku",
     "Wustermark, Braniborsko",
     "Ukázka u outletového centra: rampa, nabíjecí bod, strom."
    ]
   ]
  },
  "ablauf": {
   "kicker": "JAK PROBÍHÁ PROJEKT",
   "h2a": "Vše z jedné ruky. ",
   "h2b": "Ve čtyřech krocích.",
   "steps": [
    [
     "Poptávka",
     "Řeknete nám, o jaké místo jde a co má umět."
    ],
    [
     "Lokalita a financování",
     "Prověříme místo a ukážeme, jaké financování je vhodné."
    ],
    [
     "Plánování",
     "Uspořádání, varianty, výsadba a osvětlení pro Vaše místo."
    ],
    [
     "Dodání a instalace",
     "Dodací lhůta přibližně 2 až 3 měsíce dle počtu kusů. Instalace bez základů."
    ]
   ]
  },
  "anwendungen": {
   "kicker": "VYUŽITÍ",
   "h2a": "Kde chcete ",
   "h2b": "začít?",
   "links": [
    [
     "/en/climate-adaptation-street-space",
     "Adaptace na klima a ochrana před horkem"
    ],
    [
     "/en/vehicle-security-barriers-pedestrian-zones",
     "Pěší zóny a centra měst"
    ],
    [
     "/en/vehicle-security-barriers-christmas-markets",
     "Vánoční trhy"
    ],
    [
     "/en/vehicle-barriers-events",
     "Akce a městské slavnosti"
    ],
    [
     "/en/vehicle-protection-cultural-venues",
     "Kulturní místa a náměstí"
    ],
    [
     "/en/vehicle-protection-government-buildings",
     "Úřady a veřejné budovy"
    ]
   ]
  },
  "foerderung": {
   "kicker": "FINANCOVÁNÍ",
   "h2a": "Jeden partner pro ",
   "h2b": "řešení i financování.",
   "p": "Adaptace na klima, houbové město, městská zeleň a kvalita veřejného prostoru: na tyto účely existují zdroje veřejného financování, národní i evropské. Pomůžeme Vám najít ten, který odpovídá Vašemu místu.",
   "cta": "Vyžádat první posouzení"
  },
  "presse": {
   "quote": "„Je to lepší, než všechno zabarikádovat.“",
   "by": "Kirstin Bauch, starostka berlínského obvodu Charlottenburg-Wilmersdorf, v listu Berliner Morgenpost (přeloženo z němčiny)",
   "kicker": "PSALI O NÁS",
   "list": "rbb24 Abendschau · radio3 · Tagesspiegel · Berliner Morgenpost · Entwicklungsstadt Berlin"
  },
  "erfinder": {
   "kicker": "VYNÁLEZCE A VÝROBCE",
   "h2a": "Vynalezeno v Berlíně.",
   "h2b": "Vyrobeno v Braniborsku.",
   "p1": "Martin Fichtelmann vyvinul Cube a chrání jej evropským patentem EP 3 486 374. Jako zahradní a krajinářský odborník ví, co rostliny na městském náměstí potřebují, a vyrábí Cube ve Wustermarku u Berlína.",
   "p2": "Jeden partner od prvního nápadu až po údržbu.",
   "alt": "Martin Fichtelmann, Erfinder des Berlin-Cube, am Breitscheidplatz in Berlin"
  },
  "kontakt": {
   "kicker": "KONTAKT",
   "h2a": "Představte si své místo",
   "h2b": "za rok.",
   "p": "Ukážeme Vám, jak může vypadat. A jak ho financovat.",
   "p2": "Napište nám krátce kde a co. Požadované podklady obdržíte e-mailem a od nás první posouzení s vhodnou cestou financování.",
   "addr": "Berliner Allee 37–39, 14641 Wustermark, Německo",
   "f": {
    "name": "Jméno",
    "org": "Město, obec nebo organizace",
    "email": "E-mail",
    "ort": "Typ místa",
    "orte": [
     "Náměstí nebo pěší zóna",
     "Vánoční trh nebo akce",
     "Horké místo nebo adaptace na klima",
     "Kulturní místo nebo úřad",
     "Něco jiného"
    ],
    "laenge": "Přibližná délka v metrech",
    "msg": "Zpráva",
    "legend": "Jaké podklady Vám smíme zaslat?",
    "docs": [
     [
      "foerderleitfaden",
      "Průvodce financováním (v němčině)"
     ],
     [
      "schwammstadt",
      "Houbové město"
     ],
     [
      "baum",
      "Strom a stín"
     ],
     [
      "klima",
      "Klima"
     ],
     [
      "wasser",
      "Voda"
     ],
     [
      "solar",
      "Solár a nabíjení"
     ],
     [
      "licht",
      "Světlo"
     ],
     [
      "bank",
      "Lavička"
     ],
     [
      "service",
      "Služby a info"
     ],
     [
      "mobil",
      "Mobilní"
     ]
    ],
    "hint1": "Vaše údaje použijeme pouze k vyřízení Vaší poptávky. Více v ",
    "hintLink": "Zásadách ochrany osobních údajů",
    "hint2": ".",
    "submit": "Odeslat poptávku a získat podklady",
    "sending": "Odesílání …",
    "ok": "Děkujeme! Osobně se vám ozveme do dvou pracovních dnů.",
    "err": "Bohužel se to nepodařilo. Napište nám prosím přímo na info@berlin-cube.de."
   }
  },
  "footer": {
   "claim": "Designed in Berlin. Built for Europe.",
   "impressum": "Tiráž",
   "datenschutz": "Ochrana osobních údajů"
  },
  "seo": {
   "title": "BERLIN-CUBE | Z bezpečnostních zón se stávají místa k životu.",
   "description": "Stín, stromy, dešťová voda a místa k sezení pro rozpálená centra měst. A k tomu ochrana proti vjezdu vozidel, testovaná při nárazové zkoušce DEKRA. Jeden modulární systém, mnoho řešení."
  },
  "kantStatus": "Červen až září 2026. Instalováno bez základů, odstraněno beze stop."
 }
};
